<template>
  <dashboard-page
    class="booking-list-page"
    title="Reservas"
    subtitle="lista de reservas do período"
  >

    <template #actions>
      <div class="d-flex align-items-center search-row">
        <div
          class="d-flex align-items-center w-100"
          style="
            padding: 7px;
            border: 0.5px solid rgb(218, 218, 218);
            border-radius: 5px;
            background-color: white;
            min-width: 20rem;
          "
        >
          <input
            class="search-input w-100"
            style="border: none"
            v-model="searchQuery"
            placeholder="buscar"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="booking-list-search-clear"
            title="Limpar busca"
            @click="clearSearchQuery"
          >
            <i class="fas fa-times"></i>
          </button>
          <i v-else class="fas fa-search text-muted"></i>
        </div>
      </div>

      <div class="d-flex align-items-center booking-list-header-actions">
        <button
          type="button"
          class="btn-icon booking-list-search-toggle search-row-mobile"
          :class="{ active: showSearchQuery }"
          @click="toggleSearchQuery"
          title="Buscar reserva"
        >
          <i class="fas fa-search"></i>
        </button>

        <!-- DROPDOWN MENU-->
        <b-row align-self="start" class="row-1 text-right mr-0 mb-0">
          <b-dropdown
            menu
            on
            right
            no-caret
            id="booking-list-actions"
            variant="secondary"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#12576e" />
              </svg>
            </template>

            <b-dropdown-item
              @click="confirmVerifyBookings()"
              active
              :loading="queriedData.length > 0"
              type="default"
            >
              <i class="no no-right-arrow"></i>verificar reservas POS
            </b-dropdown-item>

            <b-dropdown-item
              @click.prevent="openDaySummaryPanel()"
              type="default"
            >
              <i class="no no-right-arrow"></i>ver resumo do período
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </div>
    </template>

    <div class="booking-list-chrome">
    <div
      class="d-flex align-items-center search-row-mobile px-3 mb-3"
      v-if="showSearchQuery"
    >
      <div
        class="d-flex align-items-center w-100"
        style="
          padding: 7px;
          border: 0.5px solid rgb(218, 218, 218);
          border-radius: 5px;
          background-color: white;
        "
      >
        <input
          class="search-input w-100"
          style="border: none"
          v-model="searchQuery"
          placeholder="buscar"
        />
        <button
          v-if="searchQuery"
          type="button"
          class="booking-list-search-clear"
          title="Limpar busca"
          @click="clearSearchQuery"
        >
          <i class="fas fa-times"></i>
        </button>
        <i v-else class="fas fa-search text-muted"></i>
      </div>
    </div>

    <base-header class="content__title content__title--calendar">
      <b-row align-v="center">
        <b-col class="m-0" cols="8">
          <span class="font-weight-normal text-primary text-center">
            <a
              :readonly="fetchProgress > 0 && fetchProgress < 100"
              href="#"
              @click.prevent="prev"
              class="fullcalendar-btn-prev btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-left-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>

            <span
              class="booking-list-period-label font-weight-normal text-primary vertical-middle"
            >
              <span @click="openStartDatePicker">
                {{ periodStartDateLabel }}
              </span>
              <span> - </span>
              <span @click="openEndDatePicker">
                {{ periodEndDateLabel }}
              </span>
            </span>

            <date-picker
              ref="startDatePicker"
              v-model="startDate"
              @change="onStartDateChange"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <date-picker
              ref="endDatePicker"
              v-model="endDate"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              @change="onEndDateChange"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <a
              :readonly="fetchProgress > 0 && fetchProgress < 100"
              href="#"
              @click.prevent="next"
              class="fullcalendar-btn-next btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-right-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>
          </span>
        </b-col>
        <b-col cols="4" class="m-0 text-right pl-0">
          <div
            v-if="!isMobileView"
            class="d-flex align-items-center justify-content-end w-100"
          >
            <div class="bg-pick">
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'timeGridDay' }"
                @click="changeView('timeGridDay')"
              >
                Dia
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridWeek' }"
                @click="changeView('dayGridWeek')"
              >
                Semana
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridMonth' }"
                @click="changeView('dayGridMonth')"
              >
                Mês
              </button>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="
                hasVisibleMenu('operation', 'index') != 
                  hasVisibleMenu('operation', 'booking-list')
              "
            >
              <i
                style="cursor: pointer; font-size: 1.5rem; color: #12576e;align-items-center"
                class="ni ni-calendar-grid-58 pl-4"
                @click.prevent="$router.push('/operation/index')"
              ></i>
            </div>
          </div>
          <div
            v-else
            class="d-flex align-items-center justify-content-end w-100"
          >
            <b-form-select
              :value="defaultView"
              :options="viewModeOptions"
              class="booking-list-view-select"
              @change="changeView"
            />
            <div
              class="d-flex align-items-center"
              v-if="
                hasVisibleMenu('operation', 'index') !=
                  hasVisibleMenu('operation', 'booking-list')
              "
            >
              <i
                style="cursor: pointer; font-size: 1.5rem; color: #12576e;align-items-center"
                class="ni ni-calendar-grid-58 pl-4"
                @click.prevent="$router.push('/operation/index')"
              ></i>
            </div>
          </div>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt-4">
      <b-row>
        <b-col cols="12">
          <div class="booking-list-tabs-row">
            <el-tabs
              ref="bookingListTabs"
              v-model="activeTab"
              class="booking-list-tabs"
              @tab-click="handleTabChange"
            >
              <el-tab-pane
                v-if="showReservasTab"
                :label="`OPERAÇÕES (${reservasCount})`"
                name="reservas"
              ></el-tab-pane>
              <el-tab-pane
                :label="`LISTA (${todasCount})`"
                name="todas"
              ></el-tab-pane>
              <el-tab-pane
                :label="`GRUPOS (${gruposCount})`"
                name="grupos"
              ></el-tab-pane>
              <el-tab-pane
                v-if="showCotacoesTab"
                :label="`COTAÇÕES (${cotacoesCount})`"
                name="cotacoes"
              ></el-tab-pane>
              <el-tab-pane
                :label="`CANCELAMENTOS (${cancelledsCount})`"
                name="cancelamentos"
              ></el-tab-pane>
            </el-tabs>
            <div
              v-if="placeOptions.length > 1"
              class="booking-list-place-filter"
            >
              <span class="booking-list-place-filter-label">
                {{ placeFilterLabel }}
              </span>
              <span class="booking-list-place-filter-control">
                <button
                  type="button"
                  class="booking-list-place-filter-button"
                  title="Filtrar produtos"
                  @click="openPlaceFilterSelect"
                >
                  <i class="fas fa-filter"></i>
                </button>
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    </div>

    <div class="booking-list-scroll">
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <component
              :is="showVehicleTimeline ? 'time-line' : 'div'"
              v-if="fetchProgress == 100 && timelineHourGroups.length"
              class="booking-list-cards align-items-between"
              :class="{
                'booking-list-timeline': showVehicleTimeline,
                'booking-list-timeline--distribute':
                  showVehicleTimeline && distributeTab(activeTab),
              }"
              v-bind="slotListBindings"
            >
              <div
                v-for="hourGroup in timelineHourGroups"
                :key="hourGroup.key"
                class="booking-list-timeline-hour-group"
              >
              <time-line-item
                v-if="showVehicleTimeline"
                class="booking-list-timeline-hour"
                :class="{
                  'booking-list-timeline-hour--muted': !hourGroup.hasCapacity,
                }"
                :badge-type="hourGroup.hasCapacity ? 'primary' : 'secondary'"
              >
                <span
                  slot="badge"
                  class="timeline-step"
                  :class="hourGroup.hasCapacity ? 'badge-primary' : 'badge-secondary'"
                >
                  <span
                    v-if="hourGroup.hourLabel"
                    class="booking-list-timeline-hour-mark"
                    :class="{
                      'booking-list-timeline-hour-mark--long':
                        hourGroup.hourLabel.length > 3,
                    }"
                  >{{ hourGroup.hourLabel }}</span>
                  <i v-else class="fas fa-clock"></i>
                </span>
                <div class="booking-list-timeline-slot">
                  <div class="booking-list-timeline-meta">
                    <small class="booking-list-timeline-hour-label">
                      <span class="booking-list-timeline-hour-text">{{
                        hourGroup.label
                      }}</span>
                      <button
                        v-if="!distributeTab(activeTab)"
                        type="button"
                        class="btn-icon-outline booking-list-resources-button"
                        title="Disponibilidade e veículos"
                        :disabled="!hourCanEditResources(hourGroup)"
                        @click="openHourResources(hourGroup)"
                      >
                        <i class="fas fa-car"></i>
                      </button>
                      <button
                        v-if="hourGroup.dateKey && !distributeTab(activeTab)"
                        type="button"
                        class="btn-icon-outline booking-list-resources-button"
                        title="Criar reserva"
                        @click="openConfirmedDepartures(hourGroup)"
                      >
                        <i class="fas fa-calendar-check"></i>
                      </button>
                    </small>
                  </div>
                </div>
              </time-line-item>
              <template v-for="(bookingsDayList, index) in hourGroup.slots">
              <component
                :is="showVehicleTimeline ? 'time-line-item' : 'div'"
                :key="`${hourGroup.key}-${index}`"
                :class="slotItemClass(bookingsDayList)"
                v-bind="slotItemBindings(bookingsDayList)"
                @click.native="onEmptySlotClick(bookingsDayList)"
              >
                <div
                  v-if="showVehicleTimeline && !slotShowsVehicleBoard(bookingsDayList)"
                  class="booking-list-timeline-line"
                >
                  <span v-html="timelineLineLabel(bookingsDayList)"></span>
                  <span class="booking-list-timeline-line-side">
                    <button
                      v-if="
                        slotVehicleSummary(bookingsDayList) &&
                        !slotHasPassed(bookingsDayList)
                      "
                      type="button"
                      class="booking-list-vehicle-summary booking-list-vehicle-summary--action"
                      @click.stop="openSlotResources(bookingsDayList)"
                    >
                      {{ slotVehicleSummary(bookingsDayList) }}
                    </button>
                    <span
                      v-else-if="slotVehicleSummary(bookingsDayList)"
                      class="booking-list-vehicle-summary"
                    >
                      {{ slotVehicleSummary(bookingsDayList) }}
                    </span>
                  </span>
                </div>

                <template v-else>
                <div
                  v-if="showVehicleTimeline"
                  class="booking-list-timeline-slot"
                >
                  <div class="booking-list-timeline-meta">
                    <small>
                      <span>{{ slotTimelineWhen(bookingsDayList) }}</span>
                      <template
                        v-if="bookingsDayList[2] && bookingsDayList[2].placeName"
                      >
                        <span> | </span>
                        <span
                        >{{ bookingsDayList[2].placeName }}</span>
                      </template>
                    </small>
                    <span
                      v-if="!distributeTab(activeTab)"
                      class="booking-list-timeline-actions"
                    >
                      <a
                        v-if="bookingsDayList[1].length"
                        href="#"
                        class="booking-list-batch-link"
                        title="Alterar em lote"
                        @click.prevent="openBatchAssign(bookingsDayList)"
                      ><i class="fas fa-edit"></i></a>
                      <button
                        v-if="canAddSlotVehicle"
                        type="button"
                        class="booking-list-batch-link"
                        title="Disponibilidade e veículos"
                        @click.stop="openSlotResources(bookingsDayList)"
                      >
                        <i class="fas fa-car"></i>
                      </button>
                      <span
                        v-if="slotVehicleSummary(bookingsDayList)"
                        class="booking-list-vehicle-summary"
                      > | {{ slotVehicleSummary(bookingsDayList) }}
                      </span>
                    </span>
                  </div>
                </div>
                <div v-else-if="!listByConductor" class="booking-list-slot-header">
                  <div
                    class="pl-2 pt-2 mb-0 booking-list-slot-title"
                    :class="{
                      'text-muted': 1,
                    }"
                    style="text-transform: uppercase"
                  >
                    <span v-html="bookingsDayList[0]"></span>
                    <button
                      v-if="slotOverbooked(bookingsDayList)"
                      type="button"
                      class="booking-list-overbooking-button"
                      title="Horário com overbooking"
                      @click="showOverbookingModal = true"
                    >
                      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    </button>
                  </div>
                  <a
                    v-if="bookingsDayList[1].length && showSlotVehicleActions"
                    href="#"
                    class="booking-list-batch-link"
                    title="Alterar em lote"
                    @click.prevent="openBatchAssign(bookingsDayList)"
                  >
                    <i class="fas fa-edit"></i>
                    alterar em lote
                  </a>
                  <button
                    v-if="canAddSlotVehicle && showSlotVehicleActions"
                    type="button"
                    class="booking-list-batch-link"
                    title="Disponibilidade e veículos"
                    @click="openSlotResources(bookingsDayList)"
                  >
                    <i class="fas fa-car"></i>
                  </button>
                  <span
                    v-if="slotVehicleSummary(bookingsDayList) && showSlotVehicleActions"
                    class="booking-list-vehicle-summary"
                  >
                    {{ slotVehicleSummary(bookingsDayList) }}
                  </span>
                </div>

                <template v-if="bookingsDayList[3]">
                  <div
                    class="booking-list-vehicle-group"
                      :class="{
                        'booking-list-vehicle-group--open': expandedVehicle(
                          bookingsDayList
                        ),
                        'booking-list-vehicle-group--distribute':
                          expandedVehicleIsDistribute(bookingsDayList),
                        'booking-list-vehicle-group--quote':
                          activeTab === 'cotacoes',
                        'booking-list-vehicle-group--cancelled':
                          activeTab === 'cancelamentos',
                      }"
                  >
                  <div
                    v-if="!distributeTab(activeTab)"
                    class="booking-list-vehicles"
                  >
                    <div
                      v-for="vehicle in bookingsDayList[3].vehicles"
                      :key="vehicle.key"
                      :class="[
                        'booking-list-vehicle',
                        {
                          'booking-list-vehicle--full':
                            vehicle.capacity && vehicle.people === vehicle.capacity,
                          'booking-list-vehicle--overbooked':
                            vehicle.capacity && vehicle.people > vehicle.capacity,
                          'booking-list-vehicle--none': !vehicle.capacity,
                          'booking-list-vehicle--distribute':
                            vehicle.key === 'a-distribuir',
                          'booking-list-vehicle--active':
                            isVehicleExpanded(bookingsDayList[2], vehicle.key),
                        },
                      ]"
                      @click="toggleVehicle(bookingsDayList[2], vehicle.key, $event)"
                    >
                      <div class="booking-list-vehicle-title">
                        <template v-if="vehicle.capacity">
                          <i
                            :class="vehicleFuelIconClass(vehicle)"
                            class="booking-list-vehicle-fuel"
                            aria-hidden="true"
                          ></i>
                          <strong>{{ vehicle.name }}</strong>
                          — {{ vehicle.people }}/{{ vehicle.capacity }}
                        </template>
                        <template v-else-if="vehicle.key === 'a-distribuir'">
                          <i class="fas fa-user-clock"></i>
                          <strong>{{ vehicle.name }}</strong>
                          — {{ vehicle.people }}
                          {{ vehicle.people === 1 ? 'pessoa' : 'pessoas' }}
                        </template>
                        <template v-else>
                          <i
                            :class="vehicleFuelIconClass(vehicle)"
                            class="booking-list-vehicle-fuel"
                            aria-hidden="true"
                          ></i>
                          <strong>{{ vehicle.name }}</strong>
                          — {{ vehicle.people }}/{{ vehicle.bookings.length }}
                        </template>
                      </div>
                      <div class="booking-list-vehicle-driver">
                        <template v-if="vehicle.capacity && vehicleRegisteredCapacity(vehicle) !== 0">
                          {{ vehicle.driverLabel || 'sem motorista' }}
                          <a
                            v-if="canAddSlotVehicle && vehicleRequiresDriver(vehicle)"
                            href="#"
                            class="booking-list-vehicle-driver-edit"
                            title="Motorista do carro"
                            @click.prevent.stop="
                              openVehicleDriver(bookingsDayList, vehicle)
                            "
                          >
                            <i class="fas fa-pen"></i>
                          </a>
                        </template>
                        <template v-else-if="vehicleRegisteredCapacity(vehicle) === 0">
                          {{ vehicleDescriptionText(vehicle) }}
                        </template>
                        <template v-else>sem transporte definido</template>
                      </div>
                      <div v-if="vehicle.capacity" class="booking-list-vehicle-bar">
                        <i
                          :style="{
                            width: `${Math.min(
                              100,
                              (vehicle.people / vehicle.capacity) * 100
                            )}%`,
                          }"
                        ></i>
                      </div>
                      <div v-else class="booking-list-vehicle-bar"></div>
                    </div>
                  </div>

                  <div
                    v-if="expandedVehicle(bookingsDayList)"
                    class="booking-list-vehicle-bookings"
                  >
                    <div
                      v-for="(booking, idx) in slotBookings(bookingsDayList)"
                      :key="booking.code || idx"
                      class="table booking-list-vehicle-booking"
                    >
                      <booking-list-card
                        :booking="bookingWithCostumer(booking)"
                        vehicle-view
                        @open-booking-details="setCurrentBooking($event)"
                      />
                      <div
                        v-if="
                          expandedVehiclePaxLabel(bookingsDayList, booking) ||
                          canEditBookingVehicles(booking)
                        "
                        class="booking-list-vehicle-pax"
                        :class="{
                          'booking-list-vehicle-pax--action':
                            canEditBookingVehicles(booking),
                        }"
                        @click="
                          canEditBookingVehicles(booking) &&
                            openBookingVehicles(bookingsDayList, booking)
                        "
                      >
                        <a
                          v-if="canEditBookingVehicles(booking)"
                          href="#"
                          class="booking-list-vehicle-edit"
                          @click.prevent
                        >
                        <i class="fas fa-car"></i> 
                        {{ expandedVehiclePaxLabel(bookingsDayList, booking) }}
                        </a>
                      </div>
                    </div>
                    <p
                      v-if="!slotBookings(bookingsDayList).length"
                      class="booking-list-vehicle-bookings-empty"
                    >
                      Nenhuma reserva neste veículo
                    </p>
                  </div>
                  </div>
                </template>

                <template v-else>
                  <div
                    v-if="!listByConductor && slotResourceSummary(bookingsDayList[2])"
                    class="booking-list-slot-resources pl-2"
                  >
                    {{ slotResourceSummary(bookingsDayList[2]) }}
                  </div>

                  <div
                    v-for="(booking, idx) in bookingsDayList[1]"
                    :key="booking.code || idx"
                    class="table mb-5"
                  >
                    <booking-list-card
                      :booking="bookingWithCostumer(booking)"
                      :isCompactLayout="false"
                      :show-transport="canAddSlotVehicle"
                      @open-booking-details="setCurrentBooking($event)"
                    />
                  </div>
                </template>
                </template>
              </component>
              </template>
              </div>
            </component>

            <div
              v-else-if="fetchProgress == 100"
              class="text-center text-muted py-4"
            >
              {{ emptyTabMessage }}
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
    </div>

    <!-- modals -->

    <modal-loading
      :openModal="
        fetchProgress > 0 &&
        fetchProgress < 100 &&
        !openBookingDetailsModal &&
        !vehicleBooking
      "
      :value="fetchProgress"
      :label="'Carregando... ' + fetchProgress.toFixed(0) + '%'"
    >
    </modal-loading>

    <b-sidebar
      :visible="showDaySummaryPanel"
      :bookings="billsMemBuffer"
      no-header-close
      right
      backdrop
      no-close-on-backdrop
      shadow
      width="480px"
      @change="onDaySummarySidebarChange"
    >
      <template #header>
        <b-row align-v="center" class="w-100 mt-2">
          <b-col cols="2">
            <button
              @click.prevent="closeDaySummaryPanel()"
              type="button"
              class="close"
              aria-label="Fechar"
            >
              <span class="no no-e-remove"></span>
            </button>
          </b-col>
        </b-row>
      </template>

      <div class="pr-4 pl-4">
        <h2 class="mb-3" style="color: #12576e">
          Resumo
          {{
            startDate == endDate
              ? `do dia ${new Date(
                  startDate + ' 12:00:00'
                ).toLocaleDateString()}`
              : `do período ${new Date(
                  startDate + ' 12:00:00'
                ).toLocaleDateString()} a ${new Date(
                  endDate + ' 12:00:00'
                ).toLocaleDateString()}`
          }}
        </h2>

        <day-summary
          :bookings="transformedItems"
          :selectedDate="startDate"
        ></day-summary>
      </div>
    </b-sidebar>

    <b-modal
      v-if="openBookingDetailsModal"
      v-model="openBookingDetailsModal"
      modal-class="fullscreen-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @shown="restoreListScroll"
      @hidden="restoreListScroll"
    >
      <template #modal-header>
        <h2 align-v="start" class="border-bottom w-100 text-left pb-2">
          {{ currentBookingModalTitle }}
        </h2>

        <div class="text-right">
          <button
            @click.prevent="closeBookingDetailsModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span @click.prevent="closeBookingDetailsModal">x</span>
          </button>
        </div>
      </template>

      <detalhesda-reserva
        v-if="openBookingDetailsModal"
        :bookingCode="currentBookingDetails.code"
        :startDate="startDate"
        :endDate="endDate"
        @emitUpdateBookingList="updateBookingList"
      >
      </detalhesda-reserva>
    </b-modal>

    <b-modal
      v-model="showConfirmedDeparturesModal"
      modal-class="confirmed-departures-modal"
      size="lg"
      hide-footer
      no-enforce-focus
      @hidden="clearConfirmedDepartures"
    >
      <template #modal-header>
        <div class="w-100 d-inline-block text-left">
          <h4 class="w-100 d-inline-block modal-title">
            Saídas disponíveis
            <button
              type="button"
              class="close d-inline"
              aria-label="Fechar"
              @click="closeConfirmedDepartures"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </h4>
          <span class="w-100 text-muted d-inline-block">
            <template v-if="confirmedDeparturesLabel">
              {{ confirmedDeparturesLabel }}
            </template> | Escolha uma das atividades disponíveis para essa data
          </span>
        </div>
      </template>
      <public-bookings
        v-if="showConfirmedDeparturesModal && confirmedDeparturesDate"
        hide-header
        embedded
        slot-mode="slot"
        :place-uuid="place && (place.uuid || place.place_uuid) || ''"
        :booking-date="confirmedDeparturesDate"
        :slot-time="confirmedDeparturesTime"
        @close-public-bookings-modal="closeConfirmedDepartures"
      />
    </b-modal>

    <b-modal
      v-model="showOverbookingModal"
      centered
      ok-only
      ok-title="Entendi"
      ok-variant="danger"
      title="Horário com overbooking"
    >
      <p class="mb-0">
        Este horário tem mais pessoas reservadas do que a capacidade. É
        necessário editar os veículos escalados para o horário.
      </p>
    </b-modal>

    <b-modal
      v-model="showPlaceFilterModal"
      centered
      title="Atrativos visíveis"
      ok-only
      ok-title="Confirmar"
      :ok-disabled="!placeFilterHasSelection"
      modal-class="booking-list-place-filter-modal"
      @ok="confirmPlaceFilter"
    >
      <p v-if="!placeFilterHasSelection" class="booking-list-place-filter-error">
        Selecione ao menos 1 atrativo
      </p>
      <button
        v-for="place in placeOptions"
        :key="place"
        type="button"
        class="booking-list-place-option"
        :class="{
          'booking-list-place-option--selected': isPlaceFilterSelected(place),
        }"
        @click="togglePlaceFilter(place)"
      >
        <i class="fas fa-check booking-list-place-option-check"></i>
        <span>{{ place }}</span>
      </button>
    </b-modal>

    <product-resources-modal
      :visible="showResourcesModal"
      :slot-meta="resourcesSlot"
      :saving="savingSlotResources"
      @close="closeSlotResources"
      @confirm="saveSlotResources"
      @change-product="onResourcesProductChange"
    />

    <booking-vehicle-modal
      :visible="!!vehicleBooking"
      :vehicles="vehicleBooking ? vehicleBooking.vehicles : []"
      :selected="vehicleBooking ? vehicleBooking.selected : []"
      :total-pax="vehicleBooking ? vehicleBooking.totalPax : 0"
      :seats-by-uuid="vehicleBooking ? vehicleBooking.seatsByUuid : {}"
      :product-name="vehicleBooking ? vehicleBooking.productName : ''"
      :booking-code="vehicleBooking ? vehicleBooking.bookingCode : ''"
      :customer-name="vehicleBooking ? vehicleBooking.customerName : ''"
      :slot-date-label="vehicleBooking ? vehicleBooking.slotDateLabel : ''"
      :show-availability-link="
        canAddSlotVehicle && !!(vehicleBooking && vehicleBooking.slotMeta)
      "
      :saving="savingBookingVehicles"
      @close="closeBookingVehicles"
      @confirm="saveBookingVehicles"
      @open-availability="openBookingVehiclesAvailability"
    />

    <vehicle-driver-modal
      :visible="!!vehicleDriver"
      :vehicle-name="vehicleDriver ? vehicleDriver.vehicleName : ''"
      :slot-label="vehicleDriver ? vehicleDriverSlotLabel : ''"
      :current-uuid="vehicleDriver ? vehicleDriver.currentUuid : ''"
      :saving="savingVehicleDriver"
      @close="closeVehicleDriver"
      @confirm="saveVehicleDriver"
    />

    <booking-batch-assign-modal
      v-if="batchSlot"
      :visible="!!batchSlot"
      :slot-meta="batchSlot.slotMeta"
      :bookings="batchSlot.bookings"
      :vehicles="batchSlot.vehicles"
      :allocation-labels="batchSlot.allocationLabels"
      :seats-by-hash="batchSlot.seatsByHash"
      :saving="savingBatch"
      :progress="batchProgress"
      @close="closeBatchAssign"
      @confirm="saveBatchAssign"
    />
  </dashboard-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import usePaginateTable from '../../Composables/usePaginateTable'
import DetalhesdaReserva from './DetalhesdaReserva.vue'
import DaySummary from './DaySummary.vue'
import BookingListCard from './BookingListCard.vue'
import ProductResourcesModal from './ProductResourcesModal.vue'
import BookingBatchAssignModal from './BookingBatchAssignModal.vue'
import BookingVehicleModal from './BookingVehicleModal.vue'
import VehicleDriverModal from './VehicleDriverModal.vue'
import PublicBookings from '@/views/Products/PublicBookings.vue'
import TimeLine from '@/components/Timeline/TimeLine.vue'
import TimeLineItem from '@/components/Timeline/TimeLineItem.vue'
import nodeService from '@/services/nodejs'
import { visibilityMapFromProducts } from '@/store/utils/productVisibility'
import {
  hasModule,
  isSystemAdmin,
  hasRole,
  hasVehiclesMenu,
  hasVisibleRole,
} from '../../store/utils/users'
import vehicleCatalog, {
  fuelCategoryFor,
} from '@/services/nodejs/vehicleResources'
import {
  allocateSlotVehicles,
  blockInterval,
  bookingPeopleCount,
  bookingSeats,
  vehicleRequiresDriver as slotVehicleRequiresDriver,
  vehicleRegisteredCapacity as slotVehicleRegisteredCapacity,
  vehicleFuelCategory,
  vehicleDescription,
  intervalsOverlap,
} from './vehicleAllocation'
import { ensureBookingCostumer, bookingOwnerName } from './bookingIdentity'

// Reservas por chamada do lote (ver saveBatchAssign)
const BATCH_CHUNK_SIZE = 10

import moment from 'moment'
import swal from 'sweetalert2'
import { DatePicker, Tabs, TabPane } from 'element-ui'
import { isMobile } from '../../store/utils/general'

export default {
  component: 'BookingList',

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    const total = paginateTable.total
    const from = paginateTable.from
    const to = paginateTable.to
    const queriedData = paginateTable.queriedData
    const pagination = paginateTable.getPagination()
    const billItems = paginateTable.getBillsItems()
    const searchQuery = paginateTable.searchQuery

    function createFuseSearch(keys) {
      return paginateTable.createFuseSearch(keys)
    }
    function setBillItems(items) {
      return paginateTable.setBillsItems(items)
    }
    function setSearchedData(items) {
      return paginateTable.setSearchedData(items)
    }
    function getFuseSearch() {
      return paginateTable.getFuseSearch()
    }

    return {
      total,
      from,
      to,
      queriedData,
      pagination,
      billItems,
      searchQuery,
      createFuseSearch,
      setBillItems,
      setSearchedData,
      getFuseSearch,
    }
  },

  components: {
    DatePicker,
    ModalLoading,
    DetalhesdaReserva,
    DaySummary,
    BookingListCard,
    ProductResourcesModal,
    BookingBatchAssignModal,
    BookingVehicleModal,
    VehicleDriverModal,
    TimeLine,
    TimeLineItem,
    PublicBookings,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },

  data() {
    return {
      openModalLoading: false,
      fetchProgress: 0,
      defaultView: 'timeGridDay',
      isMobileView: isMobile(),
      viewModeOptions: [
        { value: 'timeGridDay', text: 'Dia' },
        { value: 'dayGridWeek', text: 'Semana' },
        { value: 'dayGridMonth', text: 'Mês' },
      ],
      startDate: null,
      endDate: null,
      showDaySummaryPanel: false,
      showSearchQuery: false,
      daySummary: {},
      billsMemBuffer: [],
      openBookingDetailsModal: false,
      currentBookingDetails: null,
      listScrollTop: 0,
      searchQueryValue: '',
      activeTab: 'reservas',
      //defaultGroupBy: 'condutor',
      selectedPlaces: [],
      placeProducts: [],
      placeFilterTouched: false,
      placeFilterDraft: [],
      showPlaceFilterModal: false,
      showResourcesModal: false,
      showOverbookingModal: false,
      showConfirmedDeparturesModal: false,
      confirmedDeparturesDate: '',
      confirmedDeparturesTime: '',
      resourcesSlot: null,
      savingSlotResources: false,
      expandedVehicles: {},
      quotationExpandedVehicles: {},
      cancelledExpandedVehicles: {},
      batchSlot: null,
      savingBatch: false,
      batchProgress: null,
      vehicleBooking: null,
      vehicleBookingResume: null,
      // Aberto por "abrir vagas": o reload da lista não pode consumir a retomada
      deferVehicleBookingResume: false,
      vehicleDriver: null,
      savingVehicleDriver: false,
      savingBookingVehicles: false,
    }
  },

  watch: {
    fetchBillsFailures(failures) {
      clearTimeout(this.fetchFailuresNoticeTimer)
      if (!failures.length) return
      // Junta as falhas da mesma carga (cada dia falha em um momento) num aviso só
      this.fetchFailuresNoticeTimer = setTimeout(() => {
        const days = this.fetchBillsFailures
          .map((item) => item.startDate)
          .sort()
          .map((date) => moment(date).format('DD/MM'))
          .join(', ')
        this.$notify({
          message: `Não foi possível carregar as reservas de ${days}. A lista está incompleta: recarregue a página.`,
          // $notify é o do element-ui: duration 0 = só fecha manualmente
          duration: 0,
          type: 'danger',
        })
      }, 1000)
    },

    poisList(newValue, oldValue) {
      if (newValue && newValue.length) {
        const placeUuid =
          (this.place && (this.place.uuid || this.place.janooUserUuid)) || ''
        this.loadProductVisibility(placeUuid)
      }
      if (newValue) {
        this.recreateSearchableTable()
      }
    },

    placeOptions: {
      handler(places) {
        this.syncSelectedPlaces(places || [])
      },
      immediate: true,
    },

    transformedItems(newValue, oldValue) {
      if (newValue) {
        this.recreateSearchableTable()
        this.applyAllPerPage()
      }
    },

    verifiedBookings(newValue, oldValue) {
      console.log('verifiedBookings',newValue, oldValue)
      const start = moment(this.startDate)

      if (newValue == true) {
        this.$notify({
          message: `Reservas do dia ${start.format('DD/MM/YYYY')} verificadas.`,
          duration: 3000,
          type: 'success',
        })
        this.loadReport(start, start)
      } else if (newValue == false) {
        this.$notify({
          message: `Erro ao verificar reservas`,
          duration: 3000,
          type: 'error',
        })
      }
    },

    activeTab(tab) {
      this.$nextTick(() => {
        this.scrollActiveTabIntoView()
        if (this.distributeTab(tab)) this.expandDistributeGroups(true)
      })
    },

    timelineHourGroups() {
      if (!this.distributeTab(this.activeTab)) return
      this.expandDistributeGroups(false)
    },

    cancelledsCount() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },

    cotacoesCount() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },

    reservasCount() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },

    todasCount() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },

    gruposCount() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },

    showReservasTab() {
      this.ensureVisibleTab()
    },

    showCotacoesTab() {
      this.ensureVisibleTab()
    },
  },

  computed: {
    ...mapGetters('auth', {
      roles: 'getRules',
      place: 'getPlace',
      user: 'user',
    }),
    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    ...mapGetters('report', {
      transformedItems: 'getBookings',
      fetchBillsFailures: 'getFetchBillsFailures',
      fetchBillsInProgress: 'getFetchBillsInProgress',
    }),

    ...mapGetters('operacao', {
      verifiedBookings: 'getVerifiedBookings',
      bookingPaidStatusArray: 'getBookingPaidStatusArray',
    }),
    ...mapGetters('agent', {
      agents: 'getAgents',
    }),

    confirmedDeparturesLabel() {
      if (!this.confirmedDeparturesDate) return ''
      const parsed = moment(this.confirmedDeparturesDate, 'YYYY-MM-DD')
      if (!parsed.isValid()) return ''
      const weekday = parsed.format('ddd')
      const weekdayLabel = weekday
        ? weekday.charAt(0).toUpperCase() + weekday.slice(1)
        : ''
      const time = this.confirmedDeparturesTime
        ? this.formatHourLabel(this.confirmedDeparturesTime)
        : ''
      return [weekdayLabel, parsed.format('DD/MM/YYYY'), time]
        .filter(Boolean)
        .join(' · ')
    },

    currentBookingModalTitle() {
      if (this.openBookingDetailsModal) {
        return `Detalhes da reserva #${this.currentBookingDetails.code}`
      }
      return ''
    },

    poisByProductPlace() {
      const products = (this.poisList || []).filter(
        (poi) => this.isScheduleProduct(poi) && this.isActiveProduct(poi)
      )
      return this.groupBy(products, (poi) => this.productGroupName(poi))
    },

    placeOptions() {
      return (this.poisByProductPlace || [])
        .map((entry) => entry[0])
        .filter((placeName) => placeName)
        .sort((left, right) => String(left).localeCompare(String(right)))
    },

    placeFilterLabel() {
      const count = (this.selectedPlaces || []).length
      return count === 1 ? '1 atrativo' : `${count} atrativos`
    },

    placeFilterHasSelection() {
      return (this.placeFilterDraft || []).length > 0
    },

    visiblePlaceNames() {
      if (this.placeOptions.length <= 1) return this.placeOptions
      const selected = new Set(this.selectedPlaces || [])
      return this.placeOptions.filter((placeName) => selected.has(placeName))
    },

    bookingsForSchedule() {
      const items = this.activeTabBookings || []
      const query = String(this.searchQuery || '').trim()
      if (!query) return items

      const fuse = this.getFuseSearch()
      if (!fuse || typeof fuse.search !== 'function') return []

      return fuse.search(query).map((result) => {
        return result && result.item !== undefined ? result.item : result
      })
    },

    groupedSlots() {
      return this.groupItems(this.bookingsForSchedule)
    },

    timelineHourGroups() {
      const groups = []
      ;(this.groupedSlots || []).forEach((slot) => {
        const key = this.slotHourKey(slot) || `hour-${groups.length}`
        let group = groups[groups.length - 1]
        const meta = (slot && slot[2]) || {}
        if (!group || group.key !== key) {
            group = {
            key,
            label: this.slotHourMarkerLabel(slot),
            dateKey: meta.dateKey || '',
            timeKey: meta.timeKey || '',
            hourLabel: meta.timeKey ? this.formatHourLabel(meta.timeKey) : '',
            editDateKey: '',
            editTimeKey: '',
            editIsPast: false,
            hasCapacity: false,
            slots: [],
          }
          groups.push(group)
        }
        if (meta.dateKey && meta.timeKey) {
          const passed = this.slotHasPassed(slot)
          if (!group.editTimeKey || (group.editIsPast && !passed)) {
            group.editDateKey = meta.dateKey
            group.editTimeKey = meta.timeKey
            group.editIsPast = passed
          }
        }
        if (this.slotHasCapacity(slot)) group.hasCapacity = true
        if (this.slotListed(slot)) group.slots.push(slot)
      })
      // O marcador do horário fica mesmo sem título de passeio. Cotação,
      // cancelamento e a lista sem veículos só mostram horário com slot.
      if (this.distributeTab(this.activeTab) || !this.showVehicleTimeline) {
        return groups.filter((group) => group.slots.length)
      }
      return groups
    },

    cotacoesBookings() {
      return (this.transformedItems || []).filter(
        (booking) => String(booking.status || '').toUpperCase() === 'UNPAID'
      )
    },

    cancelledsBookings() {
      return (this.transformedItems || []).filter(
        (booking) => String(booking.status || '').toUpperCase() === 'CANCELLED'
      )
    },

    reservasBookings() {
      return (this.transformedItems || []).filter((booking) => {
        const status = String(booking.status || '').toUpperCase()
        return status !== 'UNPAID' && status !== 'CANCELLED'
      })
    },

    cotacoesCount() {
      return this.cotacoesBookings.length
    },

    reservasCount() {
      return this.reservasBookings.length
    },

    cancelledsCount() {
      return this.cancelledsBookings.length
    },

    todasBookings() {
      return this.transformedItems || []
    },

    todasCount() {
      return this.todasBookings.length
    },

    gruposBookings() {
      return this.reservasBookings.filter((booking) => {
        const meta = this.bookingGroupMeta(booking)
        return !!(meta.agentLabel || meta.vehicleLabel)
      })
    },

    gruposCount() {
      const keys = new Set()
      this.gruposBookings.forEach((booking) => {
        keys.add(this.bookingGroupKey(booking))
      })
      return keys.size
    },

    activeTabBookings() {
      if (this.activeTab === 'cotacoes') return this.cotacoesBookings
      if (this.activeTab === 'cancelamentos') return this.cancelledsBookings
      if (this.activeTab === 'todas') return this.todasBookings
      if (this.activeTab === 'grupos') return this.gruposBookings
      return this.reservasBookings
    },

    emptyTabMessage() {
      if (this.activeTab === 'cotacoes') return 'Nenhuma cotação no período.'
      if (this.activeTab === 'cancelamentos')
        return 'Nenhuma reserva cancelada no período.'
      if (this.activeTab === 'todas') return 'Nenhuma reserva no período.'
      if (this.activeTab === 'grupos') return 'Nenhum grupo no período.'
      return 'Nenhum horário disponível para o período.'
    },

    showVehicleTimeline() {
      return (
        this.canAddSlotVehicle &&
        this.activeTab !== 'todas' &&
        this.activeTab !== 'grupos'
      )
    },

    showSlotVehicleActions() {
      return this.showVehicleTimeline && !this.distributeTab(this.activeTab)
    },

    listByConductor() {
      return this.activeTab === 'todas'
    },

    listGroupsTab() {
      return this.activeTab === 'grupos'
    },

    periodStartDateLabel() {
      if (!this.startDate) return '--'

      const start = moment(this.startDate)
      if (!start.isValid()) return '--'

      return start.format('DD/MM/YY')
    },

    periodEndDateLabel() {
      if (!this.endDate) return '--'

      const end = moment(this.endDate)
      if (!end.isValid()) return '--'

      return end.format('DD/MM/YY')
    },

    vehicleDriverSlotLabel() {
      const meta = this.vehicleDriver && this.vehicleDriver.slotMeta
      if (!meta) return ''
      const parsed = meta.block
        ? moment(meta.block, 'YYYY-MM-DD HH:mm')
        : null
      const weekday = parsed && parsed.isValid() ? parsed.format('ddd') : ''
      const weekdayLabel = weekday
        ? weekday.charAt(0).toUpperCase() + weekday.slice(1)
        : ''
      const block =
        parsed && parsed.isValid()
          ? `${weekdayLabel} · ${parsed
              .format('DD/MM · HH[h]mm')
              .replace(/h00$/, 'h')}`
          : ''
      return [meta.productName || meta.placeName, block]
        .filter(Boolean)
        .join(' · ')
    },

    showReservasTab() {
      return hasVehiclesMenu(this.roles)
    },

    showCotacoesTab() {
      return (this.placeProducts || []).some((product) =>
        this.productHasQuotationSale(product)
      )
    },

    canAddSlotVehicle() {
      return hasRole('places', 'vehicles', this.roles)
    },

    slotListBindings() {
      return this.showVehicleTimeline ? { type: 'one-side' } : {}
    },
  },

  methods: {
    hasVisibleMenu(controller, action) {
      return hasVisibleRole(controller, action, this.roles)
    },
    ...mapActions('report', [
      'fetchBillItems',
      'getBillsMemBuffer',
      'removeMemBufferItem',
      'reportStoreCommit',
    ]),

    ...mapActions('operacao', [
      'formatDaySummary',
      'verifyBookings',
      'operationStoreCommit',
    ]),
    ...mapActions('product', ['fetchPOIs', 'productStoreCommit']),
    ...mapActions('agent', ['getAllAgents']),

    toggleSearchQuery() {
      if (this.isMobileView && this.showSearchQuery) {
        this.searchQuery = ''
      }
      this.showSearchQuery = !this.showSearchQuery
    },

    clearSearchQuery() {
      this.searchQuery = ''
    },

    openPlaceFilterSelect() {
      this.placeFilterDraft = (this.selectedPlaces || []).slice()
      this.showPlaceFilterModal = true
    },

    isPlaceFilterSelected(placeName) {
      return (this.placeFilterDraft || []).includes(placeName)
    },

    togglePlaceFilter(placeName) {
      const selected = this.placeFilterDraft || []
      if (selected.includes(placeName)) {
        this.placeFilterDraft = selected.filter((place) => place !== placeName)
        return
      }
      this.placeFilterDraft = selected.concat(placeName)
    },

    confirmPlaceFilter(bvEvent) {
      if (!this.placeFilterHasSelection) {
        if (bvEvent && typeof bvEvent.preventDefault === 'function') {
          bvEvent.preventDefault()
        }
        return
      }
      this.placeFilterTouched = true
      this.selectedPlaces = this.placeFilterDraft.slice()
    },

    async openDaySummaryPanel() {
      await this.formatDaySummary(this.transformedItems).then((res) => {
        this.daySummary = res
      })
      this.showDaySummaryPanel = true
    },

    closeDaySummaryPanel() {
      this.showDaySummaryPanel = false
      this.applyAllPerPage()
    },

    onDaySummarySidebarChange(visible) {
      if (!visible) {
        this.closeDaySummaryPanel()
      }
    },

    changeView(view) {
      this.defaultView = view
      switch (view) {
        case 'timeGridDay':
          this.startDate = moment().format('YYYY-MM-DD')
          this.endDate = moment().format('YYYY-MM-DD')
          break
        case 'dayGridWeek':
          //last sunday
          this.startDate = moment().startOf('week').format('YYYY-MM-DD')
          this.endDate = moment(this.startDate)
            .endOf('week')
            .format('YYYY-MM-DD')
          break
        case 'dayGridMonth':
          this.startDate = moment().startOf('month').format('YYYY-MM-DD')
          this.endDate = moment().endOf('month').format('YYYY-MM-DD')
          break
      }
      this.loadReport()
      sessionStorage.setItem('operationViewMode', view)
    },
    async confirmVerifyBookings() {
      if (this.startDate != this.endDate) {
        this.$notify({
          message: `buscando reservas POS em ${moment(this.startDate).format(
            'DD/MM/YYYY'
          )}`,
          duration: 3000,
          type: 'warning',
        })
        this.endDate = JSON.parse(JSON.stringify(this.startDate))
        this.changeView('timeGridDay')
      }
      const start = moment(this.startDate)

      swal
        .fire({
          title: `Verificar reservas?`,
          text: `${start.format('DD/MM/YYYY')}`,
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          confirmButtonColor: '#A7AA37',
          cancelButtonText: 'Fechar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.operationStoreCommit({
              mutation: 'RESET_VERIFIED_BOOKINGS',
              value: null,
            })
            await this.verifyBookings(this.startDate)
          }
        })
    },

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    isScheduleProduct(poi) {
      const allowed = ['Passeio', 'Experiência','Evento', 'Evento']
      if (!poi) return false
      const values = [poi.type, poi.sale_unit]
      if (Array.isArray(poi.category) && poi.category[0]) {
        values.push(poi.category[0].name, poi.category[0].label)
      }
      return values.some((value) => allowed.includes(String(value || '').trim()))
    },

    async loadProductVisibility(placeUuid) {
      if (!placeUuid) return

      try {
        const response = await nodeService.getProductsByPlace(placeUuid)
        this.placeProducts = Array.isArray(response.data) ? response.data : []
        const visibilityByUuid = visibilityMapFromProducts(this.placeProducts)
        ;(this.poisList || []).forEach((product) => {
          const uuid = product && (product.uuid || product.product_uuid)
          if (!uuid) return
          const key = String(uuid).toUpperCase()
          if (!Object.prototype.hasOwnProperty.call(visibilityByUuid, key)) {
            return
          }
          product.visibility = visibilityByUuid[key]
        })
      } catch (error) {
        console.warn(
          'Não foi possível carregar a visibilidade dos atrativos:',
          error
        )
        this.placeProducts = []
      }
    },

    isActiveProduct(poi) {
      if (!poi) return false
      return (
        poi.visibility === true ||
        poi.visibility === 'true' ||
        poi.visibility === 1 ||
        poi.visibility === '1'
      )
    },

    isScheduleBooking(booking) {
      const name = this.productGroupName(booking && booking.poi)
      return !!name && this.placeOptions.includes(name)
    },

    productGroupName(entity) {
      if (!entity) return ''
      const raw =
        entity.product_name || entity.name || entity.product_place_name || ''
      return String(raw)
        .replace(/\s*\([^)]*\)/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim()
    },

    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return Array.from(map)
    },

    openStartDatePicker() {
      const picker = this.$refs.startDatePicker
      if (!picker) return

      // Element UI DatePicker: abre o painel sem exibir o input
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },
    openEndDatePicker() {
      const picker = this.$refs.endDatePicker
      if (!picker) return

      // Element UI DatePicker: abre o painel sem exibir o input
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },

    periodShiftUnit() {
      if (this.defaultView === 'dayGridWeek') return 'week'
      if (this.defaultView === 'dayGridMonth') return 'month'
      return null
    },

    syncPairedPeriodDate(changed) {
      const start = moment(this.startDate)
      const end = moment(this.endDate)
      if (changed === 'start' && !start.isValid()) return
      if (changed === 'end' && !end.isValid()) return

      const unit = this.periodShiftUnit()
      if (!unit) {
        const same =
          changed === 'start'
            ? start.format('YYYY-MM-DD')
            : end.format('YYYY-MM-DD')
        this.startDate = same
        this.endDate = same
        return
      }

      if (changed === 'start') {
        this.endDate = start.clone().add(1, unit).format('YYYY-MM-DD')
        return
      }

      this.startDate = end.clone().subtract(1, unit).format('YYYY-MM-DD')
    },

    closePeriodPickers() {
      ;['startDatePicker', 'endDatePicker'].forEach((ref) => {
        const picker = this.$refs[ref]
        if (picker) picker.pickerVisible = false
      })
    },

    onStartDateChange(value) {
      if (!value) return
      this.syncPairedPeriodDate('start')
      this.closePeriodPickers()
      this.loadReport()
    },

    onEndDateChange(value) {
      if (!value) return
      this.syncPairedPeriodDate('end')
      this.closePeriodPickers()
      this.loadReport()
    },

    prev() {
      
      switch (this.defaultView) {
        case 'timeGridDay':
          this.startDate = moment(this.startDate)
            .subtract(1, 'day')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate).subtract(1, 'day').format('YYYY-MM-DD')
          break
        case 'dayGridWeek':
          this.startDate = moment(this.startDate)
            .subtract(1, 'week')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate)
            .subtract(1, 'week')
            .format('YYYY-MM-DD')
          break
        case 'dayGridMonth':
          this.startDate = moment(this.startDate)
            .subtract(1, 'month')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate)
            .subtract(1, 'month')
            .format('YYYY-MM-DD')
          break
      }
      this.loadReport()
    },

    next() {
      switch (this.defaultView) {
        case 'timeGridDay':
          this.startDate = moment(this.startDate)
            .add(1, 'day')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate).add(1, 'day').format('YYYY-MM-DD')
          break
        case 'dayGridWeek':
          this.startDate = moment(this.startDate)
            .add(1, 'week')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate)
            .add(1, 'week')
            .format('YYYY-MM-DD')
          break
        case 'dayGridMonth':
          this.startDate = moment(this.startDate)
            .add(1, 'month')
            .format('YYYY-MM-DD')
          this.endDate = moment(this.endDate)
            .add(1, 'month')
            .format('YYYY-MM-DD')
          break
      }
      this.loadReport()
    },

    formatAgentDisplayName(agent) {
      if (!agent || !agent.name) return ''
      const nickname =
        agent.nickname != null ? String(agent.nickname).trim() : ''
      const name = agent.name != null ? String(agent.name).trim().split(' ')[0] : ''
      return nickname ? `${name} (${nickname})` : name
    },

    parseJsonObject(value) {
      if (!value) return null
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          return parsed && typeof parsed === 'object' ? parsed : null
        } catch (error) {
          return null
        }
      }
      return typeof value === 'object' ? value : null
    },

    normalizeTimeKey(start) {
      if (start == null || start === '*' || start === '') return ''
      const parsed = moment(String(start), ['HH:mm:ss', 'HH:mm', 'H:mm'], true)
      if (!parsed.isValid()) return ''
      return parsed.format('HH:mm')
    },

    formatHourLabel(timeKey) {
      return moment(timeKey, 'HH:mm').format('HH[h]mm').replace(/00$/, '')
    },

    formatDateLabel(dateKey) {
      return moment(dateKey, 'YYYY-MM-DD').format('DD MMM')
    },

    bookingPlaceName(booking) {
      return this.productGroupName(booking && booking.poi)
    },

    isPlaceVisible(placeName) {
      if (this.placeOptions.length <= 1) return true
      if (!placeName) return false
      return (this.selectedPlaces || []).includes(placeName)
    },

    syncSelectedPlaces(places) {
      const names = places || []
      // fetchPOIs zera os POIs antes de gravar de novo; não apagar o filtro
      if (!names.length) return
      if (!this.placeFilterTouched) {
        this.selectedPlaces = names.slice()
        return
      }
      const known = new Set(names)
      this.selectedPlaces = (this.selectedPlaces || []).filter((place) =>
        known.has(place)
      )
    },

    periodDateKeys() {
      const start = moment(this.startDate, 'YYYY-MM-DD')
      const end = moment(this.endDate, 'YYYY-MM-DD')
      if (!start.isValid()) return []

      const last = end.isValid() ? end.clone().startOf('day') : start.clone()
      const cursor = start.clone().startOf('day')
      if (last.isBefore(cursor, 'day')) return [last.format('YYYY-MM-DD')]

      const dates = []
      while (cursor.isSameOrBefore(last, 'day')) {
        dates.push(cursor.format('YYYY-MM-DD'))
        cursor.add(1, 'day')
      }
      return dates
    },

    buildSlotMeta(placeName, dateKey, timeKey) {
      const poi = (this.poisForPlace(placeName) || [])[0] || null
      const time = this.normalizeTimeKey(timeKey)
      return {
        placeName,
        dateKey,
        timeKey: time,
        block: `${dateKey} ${time}`,
        productUuid: (poi && poi.uuid) || '',
        productName: placeName,
      }
    },

    resourcesForBlock(poi, dateKey, timeKey) {
      const resources = this.parseJsonObject(poi && poi.resources)
      const monthKey = String(dateKey || '').slice(0, 7)
      const month = resources && resources[monthKey]
      if (!month || typeof month !== 'object') return []

      const targetTime = this.normalizeTimeKey(timeKey)
      const found = []
      Object.entries(month).forEach(([key, value]) => {
        if (!Array.isArray(value)) return
        const separator = String(key).indexOf(' ')
        const datePart = separator >= 0 ? key.slice(0, separator) : ''
        const timePart = separator >= 0 ? key.slice(separator + 1) : ''
        if (datePart !== dateKey) return
        if (this.normalizeTimeKey(timePart) !== targetTime) return
        value.forEach((item) => {
          if (item) found.push(item)
        })
      })
      return found
    },

    resourcesForSlot(meta) {
      if (!meta) return []
      const seen = new Set()
      const items = []
      this.poisForPlace(meta.placeName).forEach((poi) => {
        this.resourcesForBlock(poi, meta.dateKey, meta.timeKey).forEach(
          (item) => {
            const key = item.resource_uuid || item.resource_plate
            if (key && seen.has(key)) return
            if (key) seen.add(key)
            items.push(item)
          }
        )
      })
      return items
    },

    slotResourceSummary(meta) {
      return this.resourcesForSlot(meta)
        .map((item) => item.resource_name || item.resource_plate)
        .filter(Boolean)
        .join(' · ')
    },

    blockInterval(poi, dateKey, timeKey) {
      return blockInterval(
        this.parseJsonObject(poi && poi.availability),
        dateKey,
        timeKey
      )
    },

    vehiclesBusyElsewhere(meta) {
      const current = (this.poisList || []).find(
        (poi) => poi.uuid === meta.productUuid
      )
      const mine = this.blockInterval(current, meta.dateKey, meta.timeKey)

      const busy = {}
      ;(this.poisList || []).forEach((poi) => {
        if (poi.uuid === meta.productUuid) return
        const resources = this.parseJsonObject(poi.resources)
        const month = (resources && resources[meta.dateKey.slice(0, 7)]) || {}
        Object.entries(month).forEach(([block, items]) => {
          if (!Array.isArray(items) || block.slice(0, 10) !== meta.dateKey) return
          const other = this.blockInterval(
            poi,
            meta.dateKey,
            this.normalizeTimeKey(block.slice(11))
          )
          if (!intervalsOverlap(mine, other)) return
          items
            .filter((item) => item && item.resource_type === 'vehicle')
            .forEach((item) => {
              busy[item.resource_uuid] = `${poi.product_name} ${other.start}–${other.end}`
            })
        })
      })
      return busy
    },

    // Linha compacta: o clique na faixa abre a mesma edição do ícone do carro.
    onEmptySlotClick(group) {
      if (!this.emptySlotSelectsVehicle(group)) return
      this.openSlotResources(group)
    },

    emptySlotSelectsVehicle(group) {
      if (!this.canAddSlotVehicle || this.slotShowsVehicleBoard(group)) return false
      if (this.slotHasPassed(group)) return false
      if (this.slotHasCapacity(group)) return true
      const vehicles = group[3] && group[3].vehicles
      if (!vehicles || !vehicles.length) return true
      return !vehicles.some((vehicle) => vehicle.key !== 'a-distribuir')
    },

    slotHasCapacity(group) {
      const vehicles = group && group[3] && group[3].vehicles
      if (!vehicles || !vehicles.length) return false
      return vehicles.some((vehicle) => Number(vehicle.capacity) > 0)
    },

    // Título do passeio só com reserva ou veículo. O marcador da hora fica na
    // grade mesmo assim. Cotação e cancelamento não mostram a grade: só o
    // slot com reserva.
    slotTimelineVisible(group) {
      if (this.slotTimelineOpen(group)) return true
      return this.slotHasVehicle(group)
    },

    slotHasVehicle(group) {
      const vehicles = group && group[3] && group[3].vehicles
      if (!vehicles || !vehicles.length) return false
      return vehicles.some((vehicle) => vehicle.key !== 'a-distribuir')
    },

    slotListed(group) {
      if (this.listByConductor || this.listGroupsTab) {
        return this.slotTimelineOpen(group)
      }
      if (this.distributeTab(this.activeTab)) return this.slotTimelineOpen(group)
      if (!this.canAddSlotVehicle) return true
      return this.slotTimelineVisible(group)
    },

    hourCanEditResources(hourGroup) {
      return !!(hourGroup && hourGroup.editTimeKey)
    },

    openConfirmedDepartures(hourGroup) {
      if (!hourGroup || !hourGroup.dateKey) return
      this.confirmedDeparturesDate = hourGroup.dateKey
      this.confirmedDeparturesTime = this.normalizeTimeKey(
        hourGroup.timeKey || hourGroup.editTimeKey
      )
      this.showConfirmedDeparturesModal = true
    },

    closeConfirmedDepartures() {
      this.showConfirmedDeparturesModal = false
      this.clearConfirmedDepartures()
    },

    clearConfirmedDepartures() {
      this.confirmedDeparturesDate = ''
      this.confirmedDeparturesTime = ''
    },

    openHourResources(hourGroup) {
      if (!hourGroup || !hourGroup.editDateKey || !hourGroup.editTimeKey) return
      this.openResourcesAt(hourGroup.editDateKey, hourGroup.editTimeKey, '')
    },

    productsForBlock(dateKey, timeKey) {
      const dateMoment = moment(dateKey, 'YYYY-MM-DD')
      const time = this.normalizeTimeKey(timeKey)
      const options = []
      const seen = new Set()

      this.visiblePlaceNames.forEach((placeName) => {
        this.poisForPlace(placeName).forEach((poi) => {
          if (!poi || !poi.uuid || seen.has(poi.uuid)) return
          const times = this.availableTimeKeysForPoi(poi, dateMoment)
          if (!times.includes(time)) return
          seen.add(poi.uuid)
          const name = this.productGroupName(poi) || placeName
          options.push({
            uuid: poi.uuid,
            name,
            placeName: name,
          })
        })
      })

      options.sort((left, right) =>
        String(left.name).localeCompare(String(right.name), 'pt')
      )
      return options
    },

    resourcesForProduct(productUuid, dateKey, timeKey) {
      const poi = (this.poisList || []).find((item) => item.uuid === productUuid)
      if (!poi) return []
      return this.resourcesForBlock(poi, dateKey, timeKey)
    },

    usageForPlaceSlot(placeName, dateKey, timeKey) {
      const time = this.normalizeTimeKey(timeKey)
      const slot = (this.groupedSlots || []).find((group) => {
        const meta = group[2] || {}
        return (
          meta.placeName === placeName &&
          meta.dateKey === dateKey &&
          this.normalizeTimeKey(meta.timeKey) === time
        )
      })
      const usageByUuid = {}
      if (slot && slot[3]) {
        slot[3].vehicles
          .filter((vehicle) => vehicle.capacity && vehicle.bookings.length)
          .forEach((vehicle) => {
            usageByUuid[vehicle.key] = {
              name: vehicle.name,
              bookings: vehicle.bookings.length,
              people: vehicle.people,
            }
          })
      }
      return usageByUuid
    },

    resourcesContext(baseMeta, product, products) {
      const timeKey = this.normalizeTimeKey(baseMeta.timeKey)
      const meta = {
        placeName: product ? product.placeName : '',
        dateKey: baseMeta.dateKey,
        timeKey,
        block: `${baseMeta.dateKey} ${timeKey}`,
        productUuid: product ? product.uuid : '',
        productName: product ? product.name : '',
      }
      return {
        ...meta,
        resources: product
          ? this.resourcesForProduct(product.uuid, meta.dateKey, timeKey)
          : [],
        busyByUuid: product ? this.vehiclesBusyElsewhere(meta) : {},
        usageByUuid: product
          ? this.usageForPlaceSlot(meta.placeName, meta.dateKey, timeKey)
          : {},
        products,
      }
    },

    onResourcesProductChange(productUuid) {
      if (!this.resourcesSlot || this.savingSlotResources) return
      const products = this.resourcesSlot.products || []
      const product = productUuid
        ? products.find((item) => item.uuid === productUuid)
        : null
      if (productUuid && !product) return
      this.resourcesSlot = this.resourcesContext(
        this.resourcesSlot,
        product,
        products
      )
    },

    openResourcesAt(dateKey, timeKey, preferredUuid) {
      if (!this.canAddSlotVehicle) return
      const time = this.normalizeTimeKey(timeKey)
      if (!dateKey || !time) return
      const products = this.productsForBlock(dateKey, time)
      const product =
        products.find((item) => item.uuid === preferredUuid) || null
      this.resourcesSlot = this.resourcesContext(
        { dateKey, timeKey: time },
        product,
        products
      )
      this.showResourcesModal = true
    },

    openSlotResources(group) {
      if (!this.canAddSlotVehicle) return
      const meta = group[2]
      if (!meta || !meta.dateKey || !meta.timeKey) {
        this.$notify({
          message: 'Este horário não tem um produto para vincular recursos.',
          duration: 5000,
          type: 'warning',
        })
        return
      }
      this.openResourcesAt(meta.dateKey, meta.timeKey, meta.productUuid)
    },

    closeSlotResources() {
      if (this.savingSlotResources) return
      this.showResourcesModal = false
      this.resourcesSlot = null
      this.$nextTick(() => this.clearVehicleBookingResume(true))
    },

    formatVehicleSlotDateLabel(meta) {
      if (!meta || !meta.dateKey) return ''
      const time = this.normalizeTimeKey(meta.timeKey)
      const parsed = moment(`${meta.dateKey} ${time}`, 'YYYY-MM-DD HH:mm')
      if (!parsed.isValid()) return meta.dateKey
      return parsed
        .format('DD/MM/YYYY [às] HH[h]mm')
        .replace(/h00$/, 'h')
    },

    findSlotForVehicleBooking(resume) {
      if (!resume || !resume.bookingHash || !resume.slotMeta) return null
      const { slotMeta, bookingHash } = resume
      const time = this.normalizeTimeKey(slotMeta.timeKey)
      for (const slot of this.groupedSlots || []) {
        const meta = slot[2] || {}
        if (
          meta.dateKey !== slotMeta.dateKey ||
          this.normalizeTimeKey(meta.timeKey) !== time
        ) {
          continue
        }
        if (
          slotMeta.productUuid &&
          meta.productUuid &&
          meta.productUuid !== slotMeta.productUuid
        ) {
          continue
        }
        const booking = (slot[1] || []).find((item) => item.hash === bookingHash)
        if (booking && slot[3]) return { group: slot, booking }
      }
      return null
    },

    clearVehicleBookingResume(reopen) {
      clearTimeout(this.vehicleBookingResumeTimer)
      this.vehicleBookingResumeTimer = null
      const resume = this.vehicleBookingResume
      if (!resume) return
      this.vehicleBookingResume = null
      this.deferVehicleBookingResume = false
      if (!reopen) return
      const found = this.findSlotForVehicleBooking(resume)
      if (found) {
        this.openBookingVehicles(found.group, found.booking)
      } else if (resume.booking && resume.slotMeta) {
        // A lista pode estar no meio do reload. A reserva guardada basta.
        this.openBookingVehicles(
          [
            '',
            [resume.booking],
            resume.slotMeta,
            { vehicles: [], driverUuids: new Set() },
          ],
          resume.booking
        )
      }
      this.useSavedVehiclesIfEmpty(this.pendingSlotResources)
      this.pendingSlotResources = null
    },

    // O passeio pode ainda não refletir o PATCH. O que a pessoa acabou de
    // confirmar entra no modal mesmo assim.
    useSavedVehiclesIfEmpty(resources) {
      if (!this.vehicleBooking || this.vehicleBooking.vehicles.length) return
      const vehicles = (resources || [])
        .filter((item) => item && item.resource_uuid)
        .map((item) => ({
          uuid: item.resource_uuid,
          name: item.resource_name,
          plate: item.resource_plate,
          capacity: Number(item.resource_capacity) || 0,
          category: item.resource_category || '',
        }))
      if (!vehicles.length) return
      this.vehicleBooking = { ...this.vehicleBooking, vehicles }
    },

    // O reload zera a lista na hora e o modal de carregamento cobre a tela.
    // Reabrir antes disso perde a reserva, ou o carregamento fecha o modal.
    scheduleVehicleBookingResume() {
      clearTimeout(this.vehicleBookingResumeTimer)
      const startedAt = Date.now()
      const attempt = () => {
        this.vehicleBookingResumeTimer = null
        if (!this.vehicleBookingResume) {
          this.deferVehicleBookingResume = false
          return
        }
        const loadingModalOpen =
          this.fetchProgress > 0 &&
          this.fetchProgress < 100 &&
          !this.openBookingDetailsModal
        const found = this.findSlotForVehicleBooking(this.vehicleBookingResume)
        const ready = !this.fetchBillsInProgress && !loadingModalOpen && found
        if (ready || Date.now() - startedAt > 20000) {
          // Depois que o carregamento fecha, senão ele leva o modal junto
          this.vehicleBookingResumeTimer = setTimeout(() => {
            this.vehicleBookingResumeTimer = null
            this.$nextTick(() => this.clearVehicleBookingResume(true))
          }, 250)
          return
        }
        this.vehicleBookingResumeTimer = setTimeout(attempt, 200)
      }
      this.vehicleBookingResumeTimer = setTimeout(attempt, 200)
    },

    openBookingVehiclesAvailability() {
      const ctx = this.vehicleBooking
      if (!ctx || !ctx.slotMeta || !this.canAddSlotVehicle) return
      this.deferVehicleBookingResume = true
      this.vehicleBookingResume = {
        bookingHash: ctx.booking.hash,
        booking: ctx.booking,
        slotMeta: { ...ctx.slotMeta },
      }
      this.vehicleBooking = null
      this.openResourcesAt(
        ctx.slotMeta.dateKey,
        ctx.slotMeta.timeKey,
        ctx.slotMeta.productUuid
      )
    },

    async saveSlotResources(payload) {
      if (!payload || !payload.product_uuid || !payload.block) {
        this.$notify({
          message: 'Não foi possível identificar o produto ou o horário.',
          duration: 5000,
          type: 'warning',
        })
        return
      }

      // Carro que sai do horário sai das reservas (a API desativa nelas)
      const kept = new Set(payload.resources.map((item) => item.resource_uuid))
      const unlinking = Object.entries(this.resourcesSlot.usageByUuid || {})
        .filter(([uuid]) => !kept.has(uuid))
        .map(([, usage]) => usage)
      if (unlinking.length) {
        const answer = await swal.fire({
          title: 'Remover carro com reservas?',
          html: unlinking
            .map(
              (usage) =>
                `${usage.name}: ${usage.bookings} reserva(s), ${usage.people} pessoa(s)`
            )
            .join('<br>') +
            '<br><br>Essas reservas perdem o carro e ficam a distribuir.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover',
          cancelButtonText: 'Cancelar',
        })
        if (!answer.isConfirmed) return
      }

      this.savingSlotResources = true
      try {
        const { data } = await nodeService.updateProductResources(
          payload.product_uuid,
          payload
        )
        if (this.vehicleBookingResume) this.deferVehicleBookingResume = true
        this.showResourcesModal = false
        this.resourcesSlot = null
        this.notifyUnlinked(payload, (data && data.unlinked) || [])
        this.notifyDrivers(payload, (data && data.drivers) || [])
        await this.refreshPoisAfterResources(
          payload.product_uuid,
          payload.block,
          data
        )
        // A lista ainda tem a reserva. Reabre antes do reload, que zera a lista
        // e o modal de carregamento fechava o de veículos junto.
        const hadResume = !!this.vehicleBookingResume
        if (hadResume) {
          this.pendingSlotResources = payload.resources
          this.clearVehicleBookingResume(true)
        }
        if (unlinking.length || hadResume) {
          await this.loadReport()
        }
        if (hadResume && !this.vehicleBooking) {
          this.deferVehicleBookingResume = true
          this.scheduleVehicleBookingResume()
        } else {
          this.deferVehicleBookingResume = false
        }
      } catch (error) {
        if (!this.vehicleBookingResumeTimer) this.deferVehicleBookingResume = false
        // nodeApi3 rejeita com o response; a barreira de veículo em outro
        // atrativo volta como 422 com a mensagem pronta
        const apiMessage = error && error.data && error.data.message
        console.error('product resources update failed', {
          productUuid: payload.product_uuid,
          block: payload.block,
          resources: payload.resources.map((item) => item.resource_uuid),
          error,
        })
        this.$notify({
          message: apiMessage
            ? `Não foi possível salvar os recursos do horário: ${apiMessage}`
            : 'Não foi possível salvar os recursos do horário.',
          duration: 8000,
          type: 'danger',
        })
      } finally {
        this.savingSlotResources = false
      }
    },

    async refreshPoisAfterResources(productUuid, block, data) {
      this.applySavedProductBlock(productUuid, block, data)
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      try {
        const response = await nodeService.getPoisByVendor({
          PLACE_UUID: PLACE_UUID,
          PRODUCT_UUID: '',
          nocache: true,
        })
        const pois = response && response.data
        if (Array.isArray(pois) && pois.length) {
          this.productStoreCommit({ mutation: 'SET_POIS', value: pois })
          this.applySavedProductBlock(productUuid, block, data)
        }
      } catch (error) {
        console.error('product resources poi refresh failed', {
          productUuid,
          block,
          error,
        })
      }
    },

    applySavedProductBlock(productUuid, block, data) {
      if (!productUuid || !block) return
      const resources = (data && data.resources) || []
      const monthKey = String(block).slice(0, 7)
      const pois = (this.poisList || []).map((poi) => {
        if (poi.uuid !== productUuid) return poi
        const nextResources = { ...(this.parseJsonObject(poi.resources) || {}) }
        const resourceMonth = { ...(nextResources[monthKey] || {}) }
        if (resources.length) resourceMonth[block] = resources
        else delete resourceMonth[block]
        if (Object.keys(resourceMonth).length) {
          nextResources[monthKey] = resourceMonth
        } else {
          delete nextResources[monthKey]
        }

        const nextCapacity = { ...(this.parseJsonObject(poi.capacity) || {}) }
        const capacityMonth = { ...(nextCapacity[monthKey] || {}) }
        if (resources.length) {
          capacityMonth[block] = {
            ...(capacityMonth[block] && typeof capacityMonth[block] === 'object'
              ? capacityMonth[block]
              : {}),
            booked: data && data.booked,
            available: data && data.available,
            resources,
          }
          nextCapacity[monthKey] = capacityMonth
        } else {
          delete capacityMonth[block]
          if (Object.keys(capacityMonth).length) {
            nextCapacity[monthKey] = capacityMonth
          } else {
            delete nextCapacity[monthKey]
          }
        }

        return { ...poi, resources: nextResources, capacity: nextCapacity }
      })
      this.productStoreCommit({ mutation: 'SET_POIS', value: pois })
    },

    notifyUnlinked(payload, unlinked) {
      const failures = unlinked.reduce(
        (all, item) =>
          all.concat(
            (item.results || []).filter((result) => result.status === 'error')
          ),
        []
      )
      const removed = unlinked.reduce((sum, item) => sum + (item.ok || 0), 0)
      if (failures.length) {
        console.error('product resources unlink partially failed', {
          productUuid: payload.product_uuid,
          block: payload.block,
          failures,
        })
        this.$notify({
          message:
            `O carro não saiu de ${failures.length} reserva(s): ` +
            failures
              .map((item) => `#${item.booking_code || item.hash}: ${item.message}`)
              .join('; ') +
            '. Salve o horário de novo para tentar outra vez.',
          duration: 12000,
          type: 'danger',
        })
      } else if (removed) {
        this.$notify({
          message: `Carro removido de ${removed} reserva(s); elas estão a distribuir.`,
          duration: 6000,
          type: 'success',
        })
      }
    },

    // Recursos do bloco no formato do PATCH /products/:uuid/resources. O PATCH
    // substitui o bloco inteiro: sem repassar o driver de cada carro, salvar
    // apagaria os motoristas (e a API tiraria a cópia deles das reservas).
    // driverOverrides: resource_uuid -> uuid, null (sem motorista) ou
    // { uuid, agent } (agent = payload de booking_add_agent_handler).
    blockResourcesForPatch(meta, driverOverrides = {}) {
      const poi = (this.poisList || []).find(
        (item) => item.uuid === meta.productUuid
      )
      return this.resourcesForBlock(poi, meta.dateKey, meta.timeKey).map(
        (item) => {
          const resource = {
            resource_uuid: item.resource_uuid,
            resource_name: item.resource_name,
            resource_type: item.resource_type,
            resource_capacity: item.resource_capacity,
          }
          if (item.resource_plate) resource.resource_plate = item.resource_plate
          const override =
            item.resource_uuid in driverOverrides
              ? driverOverrides[item.resource_uuid]
              : undefined
          const driverUuid =
            override === undefined
              ? item.driver && item.driver.uuid
              : override && typeof override === 'object'
                ? override.uuid
                : override
          if (item.resource_type === 'vehicle' && driverUuid) {
            resource.driver = { uuid: driverUuid }
            if (override && typeof override === 'object' && override.agent) {
              resource.driver.agent = override.agent
            }
          }
          return resource
        }
      )
    },

    // Resultado da cópia do motorista para as reservas (resposta do PATCH)
    notifyDrivers(payload, drivers) {
      const failures = drivers.reduce(
        (all, item) =>
          all.concat(
            (item.results || []).filter((result) => result.status === 'error')
          ),
        []
      )
      if (!failures.length) return
      console.error('vehicle driver propagation partially failed', {
        productUuid: payload.product_uuid,
        block: payload.block,
        failures,
      })
      this.$notify({
        message:
          `O motorista não foi atualizado em ${failures.length} reserva(s): ` +
          failures
            .map((item) => `#${item.booking_code || item.hash}: ${item.message}`)
            .join('; ') +
          '. Salve de novo para tentar outra vez.',
        duration: 12000,
        type: 'danger',
      })
    },

    openVehicleDriver(group, vehicle) {
      if (!this.canAddSlotVehicle) return
      this.vehicleDriver = {
        slotMeta: group[2],
        vehicleKey: vehicle.key,
        vehicleName: vehicle.name,
        currentUuid: (vehicle.driver && vehicle.driver.uuid) || '',
      }
    },

    closeVehicleDriver() {
      if (this.savingVehicleDriver) return
      this.vehicleDriver = null
    },

    async saveVehicleDriver(driver) {
      const driverUuid =
        driver && typeof driver === 'object' ? driver.uuid : driver || null
      const { slotMeta, vehicleKey, vehicleName } = this.vehicleDriver
      const payload = {
        block: slotMeta.block,
        product_uuid: slotMeta.productUuid,
        resources: this.blockResourcesForPatch(slotMeta, {
          [vehicleKey]: driver || null,
        }),
      }
      this.savingVehicleDriver = true
      try {
        const { data } = await nodeService.updateProductResources(
          payload.product_uuid,
          payload
        )
        await this.refreshPoisAfterResources(
          payload.product_uuid,
          payload.block,
          data
        )
        this.vehicleDriver = null
        this.notifyDrivers(payload, (data && data.drivers) || [])
        this.$notify({
          message: driverUuid
            ? `Motorista do ${vehicleName} atualizado.`
            : `${vehicleName} ficou sem motorista.`,
          duration: 5000,
          type: 'success',
        })
        this.loadReport()
      } catch (error) {
        // Barreira (motorista em outro carro no mesmo horário) volta como 422
        const apiMessage = error && error.data && error.data.message
        console.error('vehicle driver update failed', {
          ...payload,
          vehicleKey,
          driverUuid,
          error,
        })
        this.$notify({
          message: apiMessage
            ? `Não foi possível definir o motorista: ${apiMessage}`
            : 'Não foi possível definir o motorista.',
          duration: 8000,
          type: 'danger',
        })
      } finally {
        this.savingVehicleDriver = false
      }
    },

    openBatchAssign(group) {
      const allocationLabels = {}
      if (group[3]) {
        group[3].vehicles.forEach((vehicle) => {
          Object.entries(vehicle.paxByHash).forEach(([hash, pax]) => {
            allocationLabels[hash] = (allocationLabels[hash] || []).concat(
              `${vehicle.name} (${pax})`
            )
          })
        })
      }
      this.batchSlot = {
        slotMeta: group[2],
        bookings: group[1].slice(),
        vehicles: group[3]
          ? group[3].vehicles.filter((vehicle) => vehicle.capacity)
          : [],
        allocationLabels,
        seatsByHash: group[1].reduce((all, booking) => {
          all[booking.hash] = bookingSeats(
            booking,
            group[3] ? group[3].driverUuids : new Set()
          )
          return all
        }, {}),
      }
    },

    // Mesma regra do DetalhesdaReserva, sem CANCELLED: a API recusa veículo em
    // reserva cancelada
    canEditBookingVehicles(booking) {
      const status = String(booking.status || '').toUpperCase()
      if (!(this.bookingPaidStatusArray || []).includes(status)) return false
      if (isSystemAdmin(this.roles)) return true
      const productUuid = booking.poi && booking.poi.uuid
      return (
        hasModule('enable_local_agent') &&
        (this.poisList || []).some((poi) => poi.uuid == productUuid)
      )
    },

    openBookingVehicles(group, booking) {
      const slotMeta = group[2] || {}
      const productName =
        (booking.poi && booking.poi.name) ||
        slotMeta.productName ||
        ''
      // Vagas que esta reserva pode usar: as pessoas dela no carro não contam
      const seatsByUuid = {}
      group[3].vehicles
        .filter((vehicle) => vehicle.capacity)
        .forEach((vehicle) => {
          const ownPax = vehicle.paxByHash[booking.hash] || 0
          seatsByUuid[vehicle.key] =
            vehicle.capacity - (vehicle.people - ownPax)
        })
      this.vehicleBooking = {
        booking,
        slotMeta,
        productName,
        bookingCode: (booking && booking.code) || '',
        customerName: bookingOwnerName(booking) || '',
        slotDateLabel: this.formatVehicleSlotDateLabel(slotMeta),
        // Lugares: pessoas + condutores que não dirigem nenhum carro do horário
        totalPax: bookingSeats(booking, group[3].driverUuids),
        seatsByUuid,
        vehicles: this.resourcesForSlot(group[2])
          .filter((item) => item.resource_type === 'vehicle')
          .map((item) => ({
            uuid: item.resource_uuid,
            name: item.resource_name,
            plate: item.resource_plate,
            capacity: Number(item.resource_capacity) || 0,
            category: item.resource_category || '',
          })),
        selected: (booking.vehicles || [])
          .filter((item) => item.active)
          .map((item) => ({ uuid: item.uuid, pax: item.pax })),
      }
    },

    closeBookingVehicles() {
      if (this.savingBookingVehicles) return
      this.vehicleBooking = null
      // Fechar para abrir vagas dispara o hide deste modal. A retomada fica.
      if (this.deferVehicleBookingResume) return
      this.vehicleBookingResume = null
    },

    async saveBookingVehicles(vehicles) {
      const { booking } = this.vehicleBooking
      const payload = {
        hash: booking.hash,
        vehicles: vehicles.map((vehicle) => ({
          resource_uuid: vehicle.uuid,
          pax: vehicle.pax,
        })),
      }

      this.savingBookingVehicles = true
      try {
        await nodeService.postSetBookingVehicles(payload)
        this.vehicleBooking = null
        this.$notify({
          message: `Veículos da reserva #${booking.code} atualizados.`,
          duration: 5000,
          type: 'success',
        })
        this.loadReport()
      } catch (error) {
        // nodeApi3 rejeita com o response; a mensagem de validação vem em data
        const apiMessage = error && error.data && error.data.message
        console.error('booking set vehicles failed', {
          code: booking.code,
          ...payload,
          error,
        })
        this.$notify({
          message: apiMessage
            ? `Não foi possível salvar os veículos da reserva #${booking.code}: ${apiMessage}`
            : `Não foi possível salvar os veículos da reserva #${booking.code}.`,
          duration: 8000,
          type: 'danger',
        })
      } finally {
        this.savingBookingVehicles = false
      }
    },

    closeBatchAssign() {
      if (this.savingBatch) return
      this.batchSlot = null
    },

    async saveBatchAssign({ hash, vehicles, agents, driver }) {
      const steps = []
      if (vehicles.length) {
        steps.push({
          label: 'veículo',
          run: (chunk) =>
            nodeService.postSetBookingVehicles({ hash: chunk, vehicles }),
        })
      }
      if (agents.length) {
        steps.push({
          label: 'condutor',
          run: (chunk) => nodeService.postAddBookingAgent({ hash: chunk, agents }),
        })
      }

      const logContext = {
        block: this.batchSlot.slotMeta.block,
        productUuid: this.batchSlot.slotMeta.productUuid,
        hash,
      }
      const bookingCode = (bookingHash) => {
        const booking = this.batchSlot.bookings.find(
          (item) => item.hash === bookingHash
        )
        return booking ? `#${booking.code}` : bookingHash
      }
      // Blocos curtos: cada reserva espera o lock na API, então um lote grande
      // numa chamada só pode passar do timeout sem o operador ver andamento
      const chunks = []
      for (let i = 0; i < hash.length; i += BATCH_CHUNK_SIZE) {
        chunks.push(hash.slice(i, i + BATCH_CHUNK_SIZE))
      }

      this.savingBatch = true
      let failureMessage = ''
      for (const step of steps) {
        let saved = 0
        this.batchProgress = { label: step.label, done: 0, total: hash.length }
        for (const chunk of chunks) {
          try {
            // Em lote a API responde 200 mesmo com falha por reserva: o desfecho
            // de cada uma vem em results[].
            const { data } = await step.run(chunk)
            const failures = ((data && data.results) || []).filter(
              (item) => item.status === 'error'
            )
            saved += chunk.length - failures.length
            this.batchProgress = { ...this.batchProgress, done: saved }
            if (failures.length) {
              console.error('booking batch assign partially failed', {
                ...logContext,
                step: step.label,
                failures,
              })
              failureMessage =
                `Atribuição de ${step.label}: ${saved} de ${hash.length} reserva(s) gravada(s). ` +
                failures
                  .map((item) => `${bookingCode(item.hash)}: ${item.message}`)
                  .join('; ') +
                '.'
              break
            }
          } catch (error) {
            console.error('booking batch assign failed', {
              ...logContext,
              step: step.label,
              chunk,
              error,
            })
            const reason =
              error && error.code === 'ECONNABORTED' ? ' (tempo esgotado)' : ''
            failureMessage = `Não foi possível atribuir o ${step.label}${reason}: ${saved} de ${hash.length} reserva(s) gravada(s).`
            break
          }
        }
        if (failureMessage) break
      }
      // Motorista é da saída: um PATCH do bloco, depois de mover as reservas
      if (!failureMessage && driver) {
        const meta = this.batchSlot.slotMeta
        const payload = {
          block: meta.block,
          product_uuid: meta.productUuid,
          resources: this.blockResourcesForPatch(meta, {
            [driver.vehicleKey]: driver.uuid,
          }),
        }
        try {
          const { data } = await nodeService.updateProductResources(
            payload.product_uuid,
            payload
          )
          this.notifyDrivers(payload, (data && data.drivers) || [])
          await this.refreshPoisAfterResources(
            payload.product_uuid,
            payload.block,
            data
          )
        } catch (error) {
          const apiMessage = error && error.data && error.data.message
          console.error('booking batch driver failed', { ...logContext, driver, error })
          failureMessage = apiMessage
            ? `Carros gravados, mas não foi possível definir o motorista: ${apiMessage}`
            : 'Carros gravados, mas não foi possível definir o motorista.'
        }
      }
      this.savingBatch = false
      this.batchProgress = null

      if (failureMessage) {
        this.$notify({
          message: `${failureMessage} Confira a lista antes de tentar de novo.`,
          duration: 12000,
          type: 'danger',
        })
      } else {
        this.batchSlot = null
        this.$notify({
          message: `Atribuído a ${hash.length} reserva(s).`,
          duration: 5000,
          type: 'success',
        })
      }
      this.loadReport()
    },

    poisForPlace(placeName) {
      const entry = (this.poisByProductPlace || []).find(
        (item) => item[0] === placeName
      )
      return entry ? entry[1] : []
    },

    scheduleLabel(parts) {
      const rest = []
      const agentChunk =
        parts.includeIdentity && parts.agentLabel
          ? `<i class="fas fa-user font-size-sm"></i> ${parts.agentLabel}`
          : ''
      const vehicleChunk =
        parts.includeIdentity && parts.vehicleLabel
          ? `<i class="fas fa-car font-size-sm"></i> ${parts.vehicleLabel}`
          : ''
      const identity = []
      if (parts.agentFirst) {
        if (agentChunk) {
          identity.push(
            `<span class="booking-list-slot-agent">${agentChunk}</span>`
          )
        }
        if (vehicleChunk) {
          identity.push(
            `<span class="booking-list-slot-agent">${vehicleChunk}</span>`
          )
        }
      }
      if (parts.placeName) {
        rest.push(parts.placeName)
      }
      if (!parts.agentFirst && vehicleChunk) {
        rest.push(vehicleChunk)
      }
      if (parts.dateKey) {
        rest.push(this.formatDateLabel(parts.dateKey))
      }
      if (parts.timeKey) rest.push(this.formatHourLabel(parts.timeKey))
      if (parts.capacityLabel) rest.push(parts.capacityLabel)
      if (!parts.agentFirst && agentChunk) {
        rest.push(agentChunk)
      }
      const restLabel = rest.join(' | ')
      if (!identity.length) return restLabel
      return `<span class="booking-list-slot-identity">${identity.join(
        ' | '
      )}</span><span class="booking-list-slot-meta">${restLabel}</span>`
    },

    placeSlotCapacity(placeName, dateKey, timeKey) {
      const monthKey = String(dateKey || '').slice(0, 7)
      let booked = 0
      let available = 0
      let found = false

      this.poisForPlace(placeName).forEach((poi) => {
        const capacity = this.parseJsonObject(poi && poi.capacity)
        const month = capacity && capacity[monthKey]
        if (!month || typeof month !== 'object') return

        Object.entries(month).forEach(([key, value]) => {
          if (!value || typeof value !== 'object') return
          if (value.booked == null && value.available == null) return

          const separator = String(key).indexOf(' ')
          const datePart = separator >= 0 ? key.slice(0, separator) : ''
          const timePart = separator >= 0 ? key.slice(separator + 1) : ''
          if (datePart !== dateKey) return
          if (this.normalizeTimeKey(timePart) !== timeKey) return

          booked += Number(value.booked) || 0
          available += Number(value.available) || 0
          found = true
        })
      })

      if (!found) return null
      const reserved = Math.round(Number(booked))
      const total = Math.round(Number(booked) + Number(available))
      return {
        label: `${reserved}/${total} pax`,
        reserved,
        overbooking: reserved > total,
      }
    },

    slotOverbooked(group) {
      return !!(group[2] && group[2].overbooking)
    },

    // Reserva no horário e nenhum carro no bloco. Carro já escalado (mesmo com
    // lugares em "A distribuir") não entra aqui. Horário sem reserva também não.
    slotWithoutVehicle(group) {
      const bookings = (group && group[1]) || []
      if (!bookings.length) return false
      const vehicles = group[3] && group[3].vehicles
      if (!vehicles || !vehicles.length) return true
      return !vehicles.some((vehicle) => vehicle.key !== 'a-distribuir')
    },

    slotHasGroupIdentity(group) {
      const bookings = (group && group[1]) || []
      return bookings.some((booking) => {
        const meta = this.bookingGroupMeta(booking)
        return !!(meta.agentLabel || meta.vehicleLabel)
      })
    },

    slotItemClass(group) {
      if (!this.showVehicleTimeline) {
        const count = group[1] ? group[1].length : 0
        const grouped =
          this.listByConductor || this.listGroupsTab
            ? this.slotHasGroupIdentity(group)
            : count > 1
        return `table ${count ? 'mb-5' : 'mb-3 booking-list-empty-group'} ${
          grouped ? 'table-grouped' : ''
        }`
      }
      return {
        'booking-list-timeline-item--empty': !this.slotShowsVehicleBoard(group),
        'booking-list-timeline-item--past': this.slotHasPassed(group),
        'booking-list-timeline-item--colored': !!this.slotProductColor(group),
      }
    },

    slotItemBindings(group) {
      if (!this.showVehicleTimeline) return {}
      const color = this.slotProductColor(group)
      const bindings = {
        badgeType: this.slotTimelineBadge(group),
        badgeIcon: this.slotTimelineIcon(group),
      }
      if (color) {
        bindings.style = {
          '--booking-product-color': color,
          '--booking-product-color-soft': this.hexToRgba(color, 0.16),
        }
      }
      return bindings
    },

    productRecordForSlot(group) {
      const meta = (group && group[2]) || {}
      const uuid = String(meta.productUuid || '').toUpperCase()
      const matchUuid = (list) =>
        (list || []).find((item) => {
          const id = item && (item.uuid || item.product_uuid)
          return id && String(id).toUpperCase() === uuid
        })
      if (uuid) {
        return matchUuid(this.placeProducts) || matchUuid(this.poisList) || null
      }
      const placeName = meta.placeName
      if (!placeName) return null
      return (
        (this.placeProducts || []).find(
          (item) => this.productGroupName(item) === placeName
        ) ||
        (this.poisForPlace(placeName) || [])[0] ||
        null
      )
    },

    normalizeHexColor(value) {
      const raw = String(value == null ? '' : value).trim()
      const match = raw.match(/^#?([0-9a-fA-F]{6})$/)
      if (!match) return ''
      return `#${match[1].toLowerCase()}`
    },

    hexToRgba(hex, alpha) {
      const normalized = this.normalizeHexColor(hex)
      if (!normalized) return ''
      const channels = parseInt(normalized.slice(1), 16)
      const red = (channels >> 16) & 255
      const green = (channels >> 8) & 255
      const blue = channels & 255
      return `rgba(${red}, ${green}, ${blue}, ${alpha})`
    },

    slotProductColor(group) {
      const product = this.productRecordForSlot(group)
      return this.normalizeHexColor(
        this.productXFieldValue(product, 'highlight_color')
      )
    },

    slotTimelineOpen(group) {
      return !!(group[1] && group[1].length)
    },

    // Capacidade no bloco já mostra os carros, mesmo sem reserva. "A distribuir"
    // só entra quando há pessoa sem transporte.
    slotShowsVehicleBoard(group) {
      return this.slotTimelineOpen(group) || this.slotHasVehicle(group)
    },

    slotTimelineWhen(group) {
      const meta = group && group[2]
      if (!meta) return ''
      const date = ''//meta.dateKey ? this.formatDateLabel(meta.dateKey) : ''
      const hour = meta.timeKey ? this.formatHourLabel(meta.timeKey) : ''
      return [date, hour].filter(Boolean).join(' · ')
    },

    slotTimelineBadge(group) {
      if (!this.slotTimelineOpen(group)) {
        return this.slotHasCapacity(group) ? 'primary' : 'secondary'
      }
      // Cotação e cancelamento não escalam carro: a ausência não é alerta.
      if (this.distributeTab(this.activeTab)) return 'primary'
      if (this.slotOverbooked(group) || this.slotWithoutVehicle(group)) return 'danger'
      const vehicles = group[3] && group[3].vehicles
      if (
        vehicles &&
        vehicles.some(
          (vehicle) => vehicle.capacity && vehicle.people > vehicle.capacity
        )
      ) {
        return 'danger'
      }
      if (group[3]) return 'primary'
      return 'info'
    },

    slotTimelineIcon(group) {
      if (this.distributeTab(this.activeTab) && this.slotTimelineOpen(group)) {
        return 'fas fa-clock font-size-sm'
      }
      if (!this.slotTimelineOpen(group)) return 'fas fa-car'
      if (this.slotOverbooked(group)) return 'fas fa-exclamation'
      if (group[3]) return 'fas fa-car'
      return 'fas fa-clock font-size-sm'
    },

    // A lista abre só com os cards. O clique no carro (ou em A distribuir) revela as reservas.
    slotBookings(group) {
      if (this.canAddSlotVehicle && group[3] && !this.expandedVehicle(group)) {
        return []
      }
      return this.expandedVehicleBookings(group)
    },

    timelineLineLabel(group) {
      return String((group && group[0]) || '')
    },

    // O marcador segue o início do passeio no POI (availability.start), não a hora cheia.
    slotHourKey(group) {
      const meta = (group && group[2]) || {}
      return `${meta.dateKey || ''}|${meta.timeKey || ''}`
    },

    slotHourMarkerLabel(group) {
      const meta = group && group[2]
      if (!meta) return ''
      const weekday = meta.dateKey
        ? moment(meta.dateKey, 'YYYY-MM-DD').format('ddd')
        : ''
      const date = meta.dateKey ? this.formatDateLabel(meta.dateKey) : ''
      const time = meta.timeKey ? this.formatHourLabel(meta.timeKey) : ''
      return [weekday, date, time].filter(Boolean).join(' · ')
    },

    slotHasPassed(group) {
      const meta = group && group[2]
      if (!meta || !meta.dateKey || !meta.timeKey) return false
      const start = this.slotStartMoment(meta.dateKey, meta.timeKey)
      return start.isValid() && start.isBefore(moment())
    },

    slotStartMoment(dateKey, timeKey) {
      return moment(`${dateKey} ${timeKey}`, 'YYYY-MM-DD HH:mm', true)
    },

    // Atraso de 1h ou mais: o horário já passou da janela em que o slot vazio ainda interessa.
    slotOlderThanOneHour(dateKey, timeKey) {
      const start = this.slotStartMoment(dateKey, timeKey)
      if (!start.isValid()) return false
      return moment().diff(start, 'minutes') >= 60
    },

    slotVehicleSummary(group) {
      const summary = group[3] && group[3].summary
      if (summary && (this.slotHasCapacity(group) || !this.canAddSlotVehicle)) {
        return summary
      }
      if (!this.canAddSlotVehicle) return ''
      return 'sem veículos - 0 vagas'
    },

    vehicleAvailabilityLabel(vehicleCount, vacancies) {
      const count = Number(vehicleCount) || 0
      const spots = Number(vacancies) || 0
      const vehicleWord = count === 1 ? 'veículo' : 'veículos'
      const vacancyWord = spots === 1 ? 'vaga' : 'vagas'
      return `${count} ${vehicleWord} - ${spots} ${vacancyWord}`
    },

    bookingDriver(booking) {
      return (
        (booking.agents || []).filter(
          (item) => (item.type === undefined || item.type === 'driver') && item.active
        )[0] || null
      )
    },

    bookingPeopleCount(booking) {
      return bookingPeopleCount(booking)
    },

    vehicleRequiresDriver(vehicle) {
      return slotVehicleRequiresDriver(vehicle, vehicleCatalog)
    },

    vehicleRegisteredCapacity(vehicle) {
      return slotVehicleRegisteredCapacity(vehicle, vehicleCatalog)
    },

    vehicleDescriptionText(vehicle) {
      return vehicleDescription(vehicle, vehicleCatalog)
    },

    vehicleFuelIconClass(vehicle) {
      const fuel = fuelCategoryFor(vehicleFuelCategory(vehicle, vehicleCatalog))
      const icon = fuel && fuel.icon
      if (!icon) return 'fas fa-car'
      return String(icon).replace(/\bfa-solid\b/g, 'fas')
    },

    vehicleSlotFor(slotMeta, bookings) {
      // Cotação e cancelamento não têm carro: um card "A confirmar" com as
      // reservas do horário. A chave segue "a-distribuir" para a expansão.
      if (this.distributeTab(this.activeTab)) {
        if (!bookings.length) return null
        const { toDistribute, driverUuids } = allocateSlotVehicles([], bookings)
        toDistribute.name = 'A confirmar'
        return {
          vehicles: [toDistribute],
          summary: '',
          driverUuids,
        }
      }

      const resources = this.resourcesForSlot(slotMeta).filter(
        (item) => item.resource_type === 'vehicle'
      )
      // Sem disponibilidade, mas com reserva: o mesmo card "A distribuir".
      if (!resources.length) {
        if (!bookings.length) return null
        const { toDistribute, driverUuids } = allocateSlotVehicles([], bookings)
        if (!toDistribute.bookings.length) return null
        return {
          vehicles: [toDistribute],
          summary: this.vehicleAvailabilityLabel(0, 0),
          driverUuids,
        }
      }

      const { vehicles, toDistribute, driverUuids } = allocateSlotVehicles(
        resources,
        bookings
      )

      // Chip mostra o motorista da saída (resources do bloco), com nome inteiro
      vehicles.forEach((vehicle) => {
        vehicle.driverLabel = this.agentFullName(vehicle.driver)
      })

      const people = vehicles.reduce(
        (sum, item) => sum + item.people,
        toDistribute.people
      )
      const capacity = vehicles.reduce(
        (sum, item) => sum + (Number(item.capacity) || 0),
        0
      )
      const vacancies = Math.max(0, capacity - people)

      return {
        vehicles: toDistribute.bookings.length
          ? [toDistribute].concat(vehicles)
          : vehicles,
        summary: this.vehicleAvailabilityLabel(vehicles.length, vacancies),
        driverUuids,
      }
    },

    agentFullName(agent) {
      if (!agent || !agent.name) return ''
      const name = String(agent.name).trim()
      const nickname = agent.nickname ? String(agent.nickname).trim() : ''
      return nickname ? `${name} (${nickname})` : name
    },

    distributeTab(tab) {
      return tab === 'cotacoes' || tab === 'cancelamentos'
    },

    vehicleExpansionMap() {
      if (this.activeTab === 'cotacoes') return this.quotationExpandedVehicles
      if (this.activeTab === 'cancelamentos') return this.cancelledExpandedVehicles
      return this.expandedVehicles
    },

    isVehicleExpanded(slotMeta, vehicleKey) {
      const key = slotMeta.block + slotMeta.placeName
      return this.vehicleExpansionMap()[key] === vehicleKey
    },

    // Cotação e cancelamento não têm carro: o grupo "A confirmar" já abre
    // selecionado, com as reservas visíveis daquele horário.
    expandDistributeGroups(reset) {
      if (!this.distributeTab(this.activeTab)) return
      const map = this.vehicleExpansionMap()
      ;(this.timelineHourGroups || []).forEach((hour) => {
        ;(hour.slots || []).forEach((slot) => {
          const vehicles = slot[3] && slot[3].vehicles
          const distribute = (vehicles || []).find(
            (vehicle) =>
              vehicle.key === 'a-distribuir' &&
              vehicle.bookings &&
              vehicle.bookings.length
          )
          if (!distribute) return
          const meta = slot[2]
          if (!meta) return
          const key = meta.block + meta.placeName
          if (!reset && map[key] !== undefined) return
          if (map[key] === 'a-distribuir') return
          this.$set(map, key, 'a-distribuir')
        })
      })
    },

    toggleVehicle(slotMeta, vehicleKey, event) {
      const key = slotMeta.block + slotMeta.placeName
      const map = this.vehicleExpansionMap()
      const next = map[key] === vehicleKey ? null : vehicleKey
      this.$set(map, key, next)
      if (!next || !event || !event.currentTarget) return
      const chip = event.currentTarget
      this.$nextTick(() => {
        if (typeof chip.scrollIntoView !== 'function') return
        chip.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        })
      })
    },

    expandedVehicle(group) {
      return group[3].vehicles.find((item) =>
        this.isVehicleExpanded(group[2], item.key)
      )
    },

    expandedVehicleIsDistribute(group) {
      const vehicle = this.expandedVehicle(group)
      return !!(vehicle && vehicle.key === 'a-distribuir')
    },

    expandedVehicleBookings(group) {
      const vehicle = this.expandedVehicle(group)
      return vehicle ? vehicle.bookings : []
    },

    expandedVehiclePaxLabel(group, booking) {
      const vehicle = this.expandedVehicle(group)
      const pax = vehicle && vehicle.paxByHash[booking.hash]
      const total = bookingSeats(booking, group[3].driverUuids)
      if (!pax) return 'sem pessoas neste veículo'
      if (vehicle.capacity && Number(pax) === Number(total)) {
        return `${pax} pessoas neste transporte`
      }
      return vehicle.capacity
        ? `${pax}/${total} pessoas neste veículo`
        : `${pax}/${total} pessoas sem transporte definido`
    },

    bookingGroupMeta(booking) {
      const date = moment(booking.data)
      const dateKey = date.isValid() ? date.format('YYYY-MM-DD') : 'invalid'
      const timeKey = date.isValid() ? date.format('HH:mm') : '99:99'
      const placeName = this.bookingPlaceName(booking)
      const agents = booking.agents || []
      const driver = this.bookingDriver(booking)
      const agentLabel = this.formatAgentDisplayName(driver)
      const vehicleSource = driver || agents[0] || null
      let vehicleLabel =
        vehicleSource && vehicleSource.vehicle
          ? String(vehicleSource.vehicle).trim()
          : ''
      if (
        vehicleLabel &&
        agentLabel &&
        vehicleLabel.toLowerCase() === agentLabel.toLowerCase()
      ) {
        vehicleLabel = ''
      }
      const agentId =
        (driver && (driver.uuid || driver.id || agentLabel)) || 'sem-condutor'
      const identityKey = this.listByConductor
        ? String(agentId)
        : `${agentId}|${vehicleLabel || 'sem-veiculo'}`

      return {
        dateKey,
        timeKey,
        placeName,
        agentId,
        agentLabel,
        vehicleLabel,
        identityKey,
      }
    },

    bookingGroupKey(booking) {
      const meta = this.bookingGroupMeta(booking)
      const identity = `${meta.agentId}|${meta.vehicleLabel || 'sem-veiculo'}`
      return `${meta.dateKey}|${meta.placeName}|${meta.timeKey}|${identity}`
    },

    isPoiTimeBlocked(poi, dateMoment, timeKey) {
      const unavailability = this.parseJsonObject(poi && poi.unavailability)
      if (!unavailability) return false

      const dateKey = dateMoment.format('YYYY-MM-DD')
      const weekday = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ][dateMoment.day()]
      const rules = []

      Object.entries(unavailability).forEach(([key, slots]) => {
        if (!Array.isArray(slots)) return
        const keyDate = moment(key, 'YYYY-MM-DD', true)
        const matchesDate =
          keyDate.isValid() && keyDate.format('YYYY-MM-DD') === dateKey
        const matchesWeekday = String(key).toLowerCase() === weekday
        if (matchesDate || matchesWeekday) rules.push(...slots)
      })

      return rules.some((rule) => {
        if (!rule || typeof rule !== 'object') return false
        if (rule.start === '*') return true
        const ruleTime = this.normalizeTimeKey(rule.start)
        if (!ruleTime) return rule.ticket === '*'
        if (rule.ticket && rule.ticket !== '*') return false
        return ruleTime === timeKey
      })
    },

    availableTimeKeysForPoi(poi, dateMoment) {
      const availability = this.parseJsonObject(poi && poi.availability)
      if (!availability || !dateMoment.isValid()) return []

      const dateKey = dateMoment.format('YYYY-MM-DD')
      const weekday = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ][dateMoment.day()]
      let slots = null

      Object.entries(availability).forEach(([key, value]) => {
        if (!Array.isArray(value)) return
        const keyDate = moment(key, 'YYYY-MM-DD', true)
        if (keyDate.isValid() && keyDate.format('YYYY-MM-DD') === dateKey) {
          slots = value
        }
      })

      if (!slots) {
        Object.entries(availability).forEach(([key, value]) => {
          if (!Array.isArray(value)) return
          if (String(key).toLowerCase() === weekday) slots = value
        })
      }

      if (!slots) return []

      return slots
        .map((slot) => this.normalizeTimeKey(slot && slot.start))
        .filter(
          (timeKey) => timeKey && !this.isPoiTimeBlocked(poi, dateMoment, timeKey)
        )
    },

    groupItems(items) {
      const list = (Array.isArray(items) ? items : []).filter((booking) => {
        return (
          this.isScheduleBooking(booking) &&
          this.isPlaceVisible(this.bookingPlaceName(booking))
        )
      })
      const slotsByTime = new Map()
      const bookedTimesByPlaceDate = new Map()

      list.forEach((booking) => {
        const meta = this.bookingGroupMeta(booking)
        const timeBucket = `${meta.dateKey}\u001f${meta.placeName}\u001f${meta.timeKey}`
        if (!slotsByTime.has(timeBucket)) slotsByTime.set(timeBucket, new Map())
        const identities = slotsByTime.get(timeBucket)
        if (!identities.has(meta.identityKey)) {
          identities.set(meta.identityKey, { meta, bookings: [] })
        }
        identities.get(meta.identityKey).bookings.push(booking)

        const placeDate = `${meta.dateKey}\u001f${meta.placeName}`
        if (!bookedTimesByPlaceDate.has(placeDate)) {
          bookedTimesByPlaceDate.set(placeDate, new Set())
        }
        bookedTimesByPlaceDate.get(placeDate).add(meta.timeKey)
      })

      const places = this.visiblePlaceNames.slice()
      list.forEach((booking) => {
        const placeName = this.bookingPlaceName(booking)
        if (placeName && !places.includes(placeName)) places.push(placeName)
      })
      places.sort((left, right) => String(left).localeCompare(String(right)))

      const groups = []
      places.forEach((placeName) => {
        const pois = this.poisForPlace(placeName)
        this.periodDateKeys().forEach((dateKey) => {
          const dateMoment = moment(dateKey, 'YYYY-MM-DD')
          const times = new Set()
          pois.forEach((poi) => {
            this.availableTimeKeysForPoi(poi, dateMoment).forEach((timeKey) =>
              times.add(timeKey)
            )
          })
          const bookedTimes = bookedTimesByPlaceDate.get(
            `${dateKey}\u001f${placeName}`
          )
          if (bookedTimes) bookedTimes.forEach((timeKey) => times.add(timeKey))

          Array.from(times)
            .sort()
            .forEach((timeKey) => {
              const identities = slotsByTime.get(
                `${dateKey}\u001f${placeName}\u001f${timeKey}`
              )
              const capacity = this.placeSlotCapacity(
                placeName,
                dateKey,
                timeKey
              )
              const capacityLabel = capacity ? capacity.label : ''
              const slotMeta = this.buildSlotMeta(placeName, dateKey, timeKey)
              const slotBookings = identities
                ? Array.from(identities.values()).reduce(
                    (all, slot) => all.concat(slot.bookings),
                    []
                  )
                : []
              const usedCapacity = capacity ? capacity.reserved : 0
              // Na lista sem veículos, horário com mais de 1h de atraso só
              // permanece se houve ocupação ou reserva. Na timeline o marcador
              // da hora continua; o título do passeio é que sai.
              if (
                (this.listByConductor || this.listGroupsTab) &&
                !slotBookings.length
              ) {
                return
              }
              if (
                !this.canAddSlotVehicle &&
                this.slotOlderThanOneHour(dateKey, timeKey) &&
                !slotBookings.length &&
                usedCapacity <= 0
              ) {
                return
              }
              const vehicleSlot =
                this.listByConductor || this.listGroupsTab
                  ? null
                  : this.vehicleSlotFor(slotMeta, slotBookings)
              if (vehicleSlot) {
                groups.push([
                  this.scheduleLabel({
                    placeName,
                    dateKey,
                    timeKey,
                    includeIdentity: false,
                  }),
                  slotBookings,
                  slotMeta,
                  vehicleSlot,
                ])
                return
              }

              if (capacity && capacity.overbooking) slotMeta.overbooking = true

              if (!identities || !identities.size) {
                groups.push([
                  this.scheduleLabel({
                    placeName,
                    dateKey,
                    timeKey,
                    includeIdentity: false,
                    capacityLabel,
                  }),
                  [],
                  slotMeta,
                ])
                return
              }

              Array.from(identities.values())
                .sort((left, right) => {
                  const leftLabel = `${left.meta.agentLabel}|${left.meta.vehicleLabel}`
                  const rightLabel = `${right.meta.agentLabel}|${right.meta.vehicleLabel}`
                  return leftLabel.localeCompare(rightLabel)
                })
                .forEach((slot) => {
                  if (
                    this.listGroupsTab &&
                    !(slot.meta.agentLabel || slot.meta.vehicleLabel)
                  ) {
                    return
                  }
                  groups.push([
                    this.scheduleLabel({
                      placeName,
                      dateKey,
                      timeKey,
                      agentLabel: slot.meta.agentLabel,
                      vehicleLabel: this.listByConductor
                        ? ''
                        : slot.meta.vehicleLabel,
                      includeIdentity: true,
                      agentFirst: this.listGroupsTab,
                      capacityLabel,
                    }),
                    slot.bookings,
                    slotMeta,
                  ])
                })
            })
        })
      })

      // Dia, depois horário, e em cada horário os passeios em ordem alfabética.
      groups.sort((left, right) => {
        const leftMeta = left[2] || {}
        const rightMeta = right[2] || {}
        const byDate = String(leftMeta.dateKey || '').localeCompare(
          String(rightMeta.dateKey || '')
        )
        if (byDate) return byDate
        const byTime = String(leftMeta.timeKey || '').localeCompare(
          String(rightMeta.timeKey || '')
        )
        if (byTime) return byTime
        return String(leftMeta.placeName || '').localeCompare(
          String(rightMeta.placeName || ''),
          'pt'
        )
      })

      return groups
    },

    productXFieldValue(product, key) {
      if (!product || !key) return null
      const unwrap = (raw) => {
        if (raw == null) return null
        if (typeof raw === 'object' && raw.value !== undefined) return raw.value
        return raw
      }
      if (product[key] != null && product[key] !== '') {
        return unwrap(product[key])
      }
      const xfields =
        this.parseJsonObject(product.xfields) || product.xfields || null
      if (!xfields || typeof xfields !== 'object') return null
      if (xfields[key] != null) return unwrap(xfields[key])
      const laravel = xfields.laravel_data
      if (laravel && typeof laravel.value === 'string') {
        const parsed = this.parseJsonObject(laravel.value)
        if (parsed && parsed[key] != null) return unwrap(parsed[key])
      }
      if (laravel && laravel[key] != null) return unwrap(laravel[key])
      return null
    },

    productHasQuotationSale(product) {
      return this.productXFieldValue(product, 'quotationsale') == true
    },

    ensureVisibleTab() {
      if (this.activeTab === 'reservas' && !this.showReservasTab) {
        this.activeTab = 'todas'
        return
      }
      if (this.activeTab === 'cotacoes' && !this.showCotacoesTab) {
        this.activeTab = this.showReservasTab ? 'reservas' : 'todas'
      }
    },

    handleTabChange() {
      this.recreateSearchableTable()
      this.$nextTick(() => {
        this.scrollActiveTabIntoView()
        this.applyAllPerPage()
      })
    },

    applyAllPerPage() {
      this.pagination.perPage = 'Todas'
      this.pagination.currentPage = 1
    },

    scrollActiveTabIntoView() {
      const root =
        (this.$refs.bookingListTabs && this.$refs.bookingListTabs.$el) ||
        this.$el
      if (!root || !root.querySelector) return

      const scrollEl = root.querySelector('.el-tabs__nav-scroll')
      const activeEl = root.querySelector('.el-tabs__item.is-active')
      if (!scrollEl || !activeEl) return

      const scrollRect = scrollEl.getBoundingClientRect()
      const activeRect = activeEl.getBoundingClientRect()
      const padding = 12
      let nextLeft = scrollEl.scrollLeft

      if (activeRect.left < scrollRect.left + padding) {
        nextLeft -= scrollRect.left + padding - activeRect.left
      } else if (activeRect.right > scrollRect.right - padding) {
        nextLeft += activeRect.right - (scrollRect.right - padding)
      } else {
        return
      }

      if (typeof scrollEl.scrollTo === 'function') {
        scrollEl.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' })
      } else {
        scrollEl.scrollLeft = Math.max(0, nextLeft)
      }
    },

    agentSearchParts(agent) {
      if (!agent) return []
      const parts = []
      const name = agent.name != null ? String(agent.name).trim() : ''
      const nickname = agent.nickname != null ? String(agent.nickname).trim() : ''
      if (name) parts.push(name)
      if (nickname) parts.push(nickname)
      return parts
    },

    bookingOperationSearchText(booking) {
      const parts = []
      const catalog = {}
      ;(this.agents || []).forEach((agent) => {
        if (agent && agent.uuid) catalog[agent.uuid] = agent
      })
      ;(booking.vehicles || []).forEach((vehicle) => {
        if (!vehicle) return
        if (vehicle.name) parts.push(String(vehicle.name).trim())
        if (vehicle.plate) parts.push(String(vehicle.plate).trim())
      })
      ;(booking.agents || []).forEach((agent) => {
        parts.push(...this.agentSearchParts(agent))
        const fromCatalog = agent && agent.uuid && catalog[agent.uuid]
        if (fromCatalog) parts.push(...this.agentSearchParts(fromCatalog))
      })

      const date = moment(booking.data)
      if (date.isValid()) {
        const meta = this.buildSlotMeta(
          this.bookingPlaceName(booking),
          date.format('YYYY-MM-DD'),
          date.format('HH:mm')
        )
        const vehicleUuids = new Set(
          (booking.vehicles || [])
            .filter((item) => item && item.active !== false && item.uuid)
            .map((item) => item.uuid)
        )
        this.resourcesForSlot(meta).forEach((item) => {
          if (!item || !item.driver) return
          if (!vehicleUuids.has(item.resource_uuid)) return
          parts.push(...this.agentSearchParts(item.driver))
          const fromCatalog = item.driver.uuid && catalog[item.driver.uuid]
          if (fromCatalog) parts.push(...this.agentSearchParts(fromCatalog))
        })
      }

      return [...new Set(parts.filter(Boolean))].join(' ')
    },

    recreateSearchableTable() {
      const items = this.activeTabBookings
      items.forEach((booking) => {
        this.$set(
          booking,
          'operationSearchText',
          this.bookingOperationSearchText(booking)
        )
      })
      items.length > 0 ? this.setBillItems(items) : this.setBillItems([])

      this.createFuseSearch([
        'data',
        'code',
        'cat',
        'status',
        'statusText',
        'seguro.searchText',
        'people.tableText.line1',
        'people.tableText.line2',
        'people.tableText.line3',
        'paymentMethod',
        'resourcePaymentMethod',
        'poi.address',
        'poi.name',
        'poi.place',
        'valor',
        'id',
        'vehicles.name',
        'vehicles.plate',
        'agents.name',
        'agents.nickname',
        'operationSearchText',
      ])

      this.applyActiveSearch()
    },

    applyActiveSearch() {
      const query = this.searchQuery
      if (!query) {
        this.setSearchedData([])
        return
      }

      const fuse = this.getFuseSearch()
      if (!fuse || typeof fuse.search !== 'function') {
        this.setSearchedData([])
        return
      }

      const results = fuse
        .search(query)
        .map((result) =>
          result && result.item !== undefined ? result.item : result
        )
      this.setSearchedData(results)
    },

    updateBookingList() {
      const openBookingCode =
        this.currentBookingDetails &&
        (this.currentBookingDetails.code ||
          this.currentBookingDetails.bookingCode ||
          this.currentBookingDetails.hash)

      this.loadReport()

      const startedAt = Date.now()
      const syncOpenBookingDetails = () => {
        if (!this.openBookingDetailsModal || !openBookingCode) return

        const updated = (this.transformedItems || []).find((booking) => {
          return (
            String(booking.code) === String(openBookingCode) ||
            String(booking.bookingCode) === String(openBookingCode) ||
            String(booking.hash) === String(openBookingCode)
          )
        })

        if (updated) {
          this.currentBookingDetails = updated
        }
      }

      const waitListThenSync = () => {
        if (this.fetchProgress >= 100 || Date.now() - startedAt > 20000) {
          syncOpenBookingDetails()
          return
        }
        setTimeout(waitListThenSync, 200)
      }

      setTimeout(waitListThenSync, 300)
    },

    fetchBillsAwait(idx, callback) {
      this.getBillsMemBuffer().then((bufferData) => {
        this.billsMemBuffer = bufferData
      })

      if (!idx) {
        idx = 1
      }
      if (this.billsMemBuffer.length >= idx) {
        this.removeMemBufferItem(idx - 1)
        idx++
      }

      let doneStatusCount = this.$store.state.report.requestArrayStatus.filter(
        (resp) => resp == 'done'
      ).length
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      let doneBufferCount = this.billsMemBuffer.filter(
        (resp) => resp == 0
      ).length

      if (
        doneStatusCount == 0 ||
        doneStatusCount < totalRequest ||
        doneBufferCount < totalRequest
      ) {
        setTimeout(
          (i, cb) => {
            this.fetchBillsAwait(i, cb)
          },
          100,
          idx
        )
      }

      this.calculateFetchProgress()
      if (this.fetchProgress == 100) {
        this.applyAllPerPage()
      }
    },

    async loadReport(startDate, endDate) {
      this.searchQueryValue = String(this.searchQuery)
      this.searchQuery = ''
      if (!this.startDate) {
        this.startDate = moment(this.todayReferenceDate)
          .startOf('month')
          .format('YYYY-MM-DD')
      }

      if (!this.endDate) {
        this.endDate = moment(this.todayReferenceDate)
          .endOf('month')
          .format('YYYY-MM-DD')
      }
      if (!startDate || !endDate) {
        startDate = this.startDate
        endDate = this.endDate
      }

      var diff = moment(endDate).diff(moment(startDate), 'days')
      if (diff < 0) {
        this.startDate = endDate
        this.endDate = startDate
      }

      if (diff > 31) {
        this.$notify({
          message: 'O período máximo permitido é de 31 dias!',
          duration: 6000,
          type: 'warning',
        })
        startDate = this.startDate
        this.endDate = moment(this.startDate)
          .add(31, 'days')
          .format('YYYY-MM-DD')
        endDate = this.endDate
      }

      this.calculateFetchProgress()
      this.fetchBillItems({
        startDate: this.startDate,
        endDate: this.endDate,
        useFakeData: false,
        daysInternval: 1,
        operation_request: false,
      })
      this.fetchBillsAwait()
      setTimeout(() => {
        this.searchQuery = this.searchQueryValue
      }, 2000)
    },

    calculateFetchProgress() {
      var totalRequest = this.$store.state.report.requestArrayStatus.length
      var done = this.billsMemBuffer.filter((resp) => resp == 0).length
      let progress = (done / totalRequest) * 100
      this.fetchProgress = done > 0 ? progress : 0.1
    },

    getTicketsDetails(booking) {
      let ticketDetails = '--'
      try {
        ticketDetails =
          booking.people.tableText && booking.people.tableText.line3
            ? booking.people.tableText.line3
            : '--'
      } catch (error) {}

      ticketDetails = `<div class="d-flex ml-3" style="font-size: small;">${ticketDetails.replaceAll(
        '),',
        ')<br>'
      )}</div>`
      return ticketDetails
    },

    getCheckinDetails(booking) {
      let ticketDetails = ''
      if (booking.checkin != undefined) {
        let checkinList =
          booking.checkin.list != undefined
            ? booking.checkin.list
            : booking.checkin
        checkinList.forEach((item) => {
          ticketDetails += `
          <div class="d-flex ml-3" style="font-size: small;">
          ${moment
            .utc(item.date, 'DD/MM/YYYY H:mm')
            .local()
            .format('DD/MM/YYYY, H:mm')}
            <div class="pl-1  d-inline" style="font-size: small; color:darkgray">(${
              item.operator || item.name
            })</div>
          </div>
          `
        })
      }
      return ticketDetails
    },

    bookingWithCostumer(booking) {
      return ensureBookingCostumer(booking)
    },

    listScrollEl() {
      return (
        (this.$el &&
          this.$el.querySelector &&
          this.$el.querySelector('.booking-list-scroll')) ||
        document.querySelector('.booking-list-scroll')
      )
    },

    captureListScroll() {
      const scroller = this.listScrollEl()
      this.listScrollTop = scroller ? scroller.scrollTop : 0
    },

    restoreListScroll() {
      const scroller = this.listScrollEl()
      if (scroller) scroller.scrollTop = this.listScrollTop
    },

    queueRestoreListScroll() {
      const restore = () => this.restoreListScroll()
      this.$nextTick(restore)
      ;[0, 50, 200, 400].forEach((ms) => {
        setTimeout(restore, ms)
      })
    },

    preserveListScroll(run) {
      this.captureListScroll()
      const restore = () => this.restoreListScroll()
      const result = typeof run === 'function' ? run() : undefined
      this.queueRestoreListScroll()
      if (result && typeof result.then === 'function') {
        result.catch(() => {}).then(restore)
      }
      return result
    },

    setCurrentBooking(booking) {
      this.preserveListScroll(() => {
        this.openBookingDetailsModal = true
        this.currentBookingDetails = booking
        if (this.$route.hash === '#booking') return Promise.resolve()
        return this.$router
          .push({
            path: this.$route.path,
            query: this.$route.query,
            hash: '#booking',
          })
          .catch(() => {})
      })
    },

    closeBookingDetailsModal() {
      this.openBookingDetailsModal = false
      this.currentBookingDetails = null
      this.queueRestoreListScroll()
      if (!this.$route.hash) return
      this.$router
        .push({
          path: this.$route.path,
          query: this.$route.query,
        })
        .catch(() => {})
        .then(() => this.restoreListScroll())
    },

    handleBack() {
      if (this.openBookingDetailsModal) {
        this.closeBookingDetailsModal()
        return
      } else {
        this.$router.back()
        return
      }
    },
  },

  async mounted() {
    const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
    await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })

    document.body.classList.add('booking-list-lock-scroll')
    this.$nextTick(() => {
      this.scrollActiveTabIntoView()
      this.applyAllPerPage()
      // Labels com contagem podem mudar a largura após o primeiro paint
      setTimeout(() => this.scrollActiveTabIntoView(), 150)
    })
    this.loadReport()
    this.getAllAgents().then(() => this.recreateSearchableTable())
  },

  created() {
    this.ensureVisibleTab()
    if (sessionStorage.getItem('operationViewMode')) {
      this.changeView(sessionStorage.getItem('operationViewMode'))
    }
    window.addEventListener('popstate', this.handleBack)

    if (!this.startDate) {
      this.startDate = moment().format('YYYY-MM-DD')
    }

    if (!this.endDate) {
      this.endDate = moment().format('YYYY-MM-DD')
    }
    this.fetchBillItems({
      startDate: this.startDate,
      endDate: this.endDate,
      useFakeData: false,
      daysInternval: 1,
      operation_request: false,
    })
    this.fetchBillsAwait()
  },

  beforeDestroy() {
    clearTimeout(this.vehicleBookingResumeTimer)
    document.body.classList.remove('booking-list-lock-scroll')
    window.removeEventListener('popstate', this.handleBack)
  },
}
</script>
<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@/assets/sass/core/vendors/fullcalendar';

.bg-pick {
  background-color: white;
  height: 25px;
  width: fit-content;
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 4px;
}

.fc-unthemed td.fc-today {
  background-color: white;
}

.fc-day-number {
  font-weight: normal;
  font-size: 13px;
  margin-right: 10px;
}
.fc-day-top {
  height: 30px;
}

.fc-today {
  font-weight: 600;
  .fc-day-number {
    background-color: #a7aa37;
    color: white;
    width: 22px;
    height: 20px;
    border-top: 4px solid #fff;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    justify-content: center;
  }
}

.fc-dayGrid-view .fc-body .fc-row {
  max-height: 100px;
}

.fc-day {
  background-color: white;
}

.fc-other-month {
  background-color: transparent;
}

.fc-event.fc-h-event {
  height: 15px !important;
  font-size: 12px !important;
}

.fc-event.fc-h-event .bc-booking-code,
.fc-event.fc-h-event .bc-client-name {
  font-size: 11px !important;
}

.fc-event-container {
  cursor: default;
}
.fc-event.fc-h-event .fc-content span {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.booking-list-period-label {
  cursor: pointer;
  user-select: none;
  font-size: 0.9rem;
}

.booking-list-period-label span:hover {
  text-decoration: underline;
}

.booking-list-hidden-datepicker {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.booking-list-hidden-datepicker .el-input__inner {
  padding: 0 !important;
  height: 0 !important;
  line-height: 0 !important;
  border: none !important;
}

.booking-list-search-input fieldset {
  margin-bottom: 0px !important;
}

.booking-list-header-actions {
  gap: 0.35rem;
}

.booking-list-search-toggle {
  color: #12576e;
  background: transparent;
  cursor: pointer;
}

.booking-list-search-toggle.active {
  background-color: #e8f4f8;
}
.booking-list-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  padding: 0;
  width: 1.35rem;
  height: 1.35rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #b11b1b;
  cursor: pointer;
  flex-shrink: 0;
}

.booking-list-search-clear:hover {
  background-color: #f8f1ee;
  color: #b11b1b;
}

body.booking-list-lock-scroll {
  overflow: hidden;
}

body.booking-list-lock-scroll .main-content {
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

body.booking-list-lock-scroll .main-content > .pb-5 {
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.booking-list-page.dashboard-page {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.booking-list-page .dashboard-page__header {
  flex-shrink: 0;
}

.booking-list-page .dashboard-page__body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.booking-list-chrome {
  flex-shrink: 0;
}

.booking-list-tabs-row {
  display: flex;
  align-items: center;
  padding-bottom: 0.75rem;
}

.booking-list-tabs {
  flex: 1 1 auto;
  min-width: 0;

  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    height: 27px;
    line-height: 27px;
  }
}

.booking-list-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.booking-list-place-filter {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  margin-left: 0.5rem;
}

.booking-list-place-filter-label {
  color: #12576e;
  font-size: 0.75rem;
}

.booking-list-place-filter-control {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.booking-list-place-filter-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  padding: 0;
  border: none;
  border-radius: 2px;
  background: transparent;
  color: #12576e;
  cursor: pointer;
}

.booking-list-place-filter-button:hover {
  background: #eef5f8;
}

.booking-list-place-filter-modal .modal-footer {
  justify-content: flex-end;
}

.booking-list-place-filter-error {
  margin: 0 0 0.75rem;
  color: #c0392b;
  font-size: 0.9rem;
  font-weight: 400;
}

.booking-list-place-option {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  padding: 0.4rem 0.2rem;
  border: 0;
  background: transparent;
  color: #12576e;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}

.booking-list-place-option:hover {
  background: #eef5f8;
}

.booking-list-place-option-check {
  width: 1.2rem;
  font-size: 1.15rem;
  color: #12576e;
  opacity: 0;
  flex-shrink: 0;
}

.booking-list-place-option--selected .booking-list-place-option-check {
  opacity: 1;
}

.booking-list-cards {
  padding: 0.5rem 0.75rem 0;
}

.booking-list-empty-group {
  opacity: 0.72;
}

.booking-list-slot-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.booking-list-slot-title {
  font-size: 0.8rem;
}
.booking-list-slot-header .h3 {
  flex: 1;
}

.booking-list-overbooking-button {
  display: inline;
  margin: 0 0 0 0.35rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  line-height: 1;
  vertical-align: baseline;
  cursor: pointer;
}

.booking-list-resources-button {
  margin: 0;
  flex-shrink: 0;
}

.booking-list-slot-resources {
  color: #12576e;
  font-size: 0.9rem;
  margin-top: -0.15rem;
  margin-bottom: 0.35rem;
}

.booking-list-batch-link {
  margin: 0.75rem 0.75rem 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #12576e;
  font-size: 0.9rem;
  line-height: 1;
  white-space: nowrap;
  box-shadow: none;
  cursor: pointer;
}

.booking-list-batch-link:hover,
.booking-list-batch-link:focus {
  color: #12576e;
  background: transparent;
  text-decoration: none;
}

.booking-list-vehicle-summary {
  margin: 0.75rem 0.75rem 0 0;
  color: #8a8f98;
  font-size: 0.9rem;
  white-space: nowrap;
}

.booking-list-vehicle-group--open {
  margin: 0.15rem 0 0.85rem;
}

.booking-list-vehicles {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 0.45rem;
  padding: 0.35rem 0 0.55rem;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.booking-list-vehicle-group--open .booking-list-vehicles {
  position: relative;
  z-index: 1;
  padding-bottom: 0;
}

.booking-list-vehicle {
  flex: 0 0 auto;
  min-width: 8.5rem;
  padding: 0.45rem 0.7rem;
  border: 1px solid rgba(125, 133, 144, 0.35);
  border-radius: 0.55rem;
  background: #eef5f8;
  color: #8a8f98;
  font-size: 0.875rem;
  line-height: 1.35;
  cursor: pointer;
}

.booking-list-vehicle-title strong {
  color: #6d7580;
  font-size: 0.95rem;
  font-weight: 600;
}

.booking-list-vehicle-title .booking-list-vehicle-fuel,
.booking-list-vehicle-title .fa-user-clock {
  margin-right: 0.3rem;
  opacity: 0.45;
}

.booking-list-vehicle-driver {
  color: #9aa1aa;
}

.booking-list-vehicle:hover:not(.booking-list-vehicle--active) {
  background: #eef5f8;
  border-color: rgba(125, 133, 144, 0.55);
}

.booking-list-vehicle-bar {
  height: 4px;
  margin-top: 0.35rem;
  border-radius: 3px;
  background: #eceff2;

  i {
    display: block;
    height: 100%;
    border-radius: 3px;
    background: #c5ced6;
  }
}

.booking-list-vehicle-bookings {
  position: relative;
  margin-top: 0;
  padding: 0.35rem 0.35rem 0.45rem;
  border: 1px solid #d5e5ee;
  border-radius: 0 0 0.55rem 0.55rem;
  background: #eef5f8;
}

.booking-list-vehicle-bookings-empty {
  margin: 0.15rem 0.35rem 0.25rem;
  color: #8a8f98;
  font-size: 0.85rem;
}

.booking-list-vehicle-booking {
  margin-bottom: 0.1rem !important;
}

.booking-list-vehicle-bookings .booking-list-vehicle-booking:last-child {
  margin-bottom: 0 !important;
}

.booking-list-vehicle-pax {
  margin-top: 0.1rem;
  padding-left: 1rem;
  padding-bottom: 0.15rem;
  color: #12576e;
  font-size: 0.85rem;
  font-weight: 400;
  border-radius: 0.35rem;
}

.booking-list-vehicle-pax--action {
  cursor: pointer;
}

.booking-list-vehicle-pax:hover {
  background: rgba(18, 87, 110, 0.08);
} 

.booking-list-vehicle-driver-edit {
  margin-left: 0.35rem;
  font-size: 0.75rem;
}

.booking-list-vehicle-edit {
  margin-left: 0.5rem;
  font-weight: normal;
}

.booking-list-vehicle--active {
  z-index: 1;
  margin-bottom: -1px;
  border-color: #d5e5ee;
  border-bottom-color: #eef5f8;
  border-radius: 0.55rem 0.55rem 0 0;
  background: #eef5f8;
  box-shadow: inset 0 2px 0 #1a6884;

  .booking-list-vehicle-title strong,
  .booking-list-vehicle-driver {
    color: #12576e;
  }

  .booking-list-vehicle-title .booking-list-vehicle-fuel,
  .booking-list-vehicle-title .fa-user-clock {
    opacity: 1;
    color: #12576e;
  }

  .booking-list-vehicle-bar {
    background: rgba(26, 104, 132, 0.16);
  }

  .booking-list-vehicle-bar i {
    background: #1a6884;
  }
}

.booking-list-vehicle--full {
  .booking-list-vehicle-bar i {
    background: #7dbe90;
  }
}

.booking-list-vehicle--overbooked {
  .booking-list-vehicle-bar i {
    background: #e07a72;
  }
}

.booking-list-vehicle--active.booking-list-vehicle--full,
.booking-list-vehicle--active.booking-list-vehicle--overbooked,
.booking-list-vehicle--active.booking-list-vehicle--none {
  border-color: #d5e5ee;
  border-bottom-color: #eef5f8;
  background: #eef5f8;
}

.booking-list-vehicle--active.booking-list-vehicle--full .booking-list-vehicle-bar i {
  background: #2d8a4e;
}

.booking-list-vehicle--active.booking-list-vehicle--overbooked {
  box-shadow: inset 0 2px 0 #c0392b;

  .booking-list-vehicle-bar i {
    background: #c0392b;
  }
}

.booking-list-vehicle--none {
  .booking-list-vehicle-bar {
    background: #b2a90f;
  }
}

.booking-list-vehicle--none.booking-list-vehicle--active {
  border-style: dashed;
}

.booking-list-vehicle--distribute.booking-list-vehicle--active {
  background: #eef5f8;
  border-color: #b2a90f;
  border-bottom-color: #eef5f8;
  box-shadow: inset 0 2px 0 #b2a90f;
}

.booking-list-vehicle-group--quote,
.booking-list-vehicle-group--cancelled {
  .booking-list-vehicle--active,
  .booking-list-vehicle--active.booking-list-vehicle--full,
  .booking-list-vehicle--active.booking-list-vehicle--overbooked,
  .booking-list-vehicle--active.booking-list-vehicle--none,
  .booking-list-vehicle-bookings {
    background: var(--booking-group-bg);
    border-color: var(--booking-group-border);
  }

  .booking-list-vehicle--active {
    border-bottom-color: var(--booking-group-bg);
    box-shadow: inset 0 2px 0 var(--booking-group-accent);
    color: var(--booking-group-ink);

    .booking-list-vehicle-title strong,
    .booking-list-vehicle-driver,
    .booking-list-vehicle-title .booking-list-vehicle-fuel,
    .booking-list-vehicle-title .fa-user-clock {
      color: var(--booking-group-ink);
    }

    .booking-list-vehicle-bar {
      background: var(--booking-group-track);
    }

    .booking-list-vehicle-bar i {
      background: var(--booking-group-accent);
    }
  }

  .booking-list-vehicle-pax {
    color: var(--booking-group-ink);
  }

  .booking-list-vehicle-pax:hover {
    background: var(--booking-group-track);
  }
}

.booking-list-vehicle-group--quote {
  --booking-group-bg: #f1f2f4;
  --booking-group-border: #e0e2e6;
  --booking-group-accent: #8b919a;
  --booking-group-ink: #5c6370;
  --booking-group-track: rgba(139, 145, 154, 0.16);
}

.booking-list-vehicle-group--cancelled {
  --booking-group-bg: #f8eeee;
  --booking-group-border: #f0d4d2;
  --booking-group-accent: #c0392b;
  --booking-group-ink: #9a4038;
  --booking-group-track: rgba(192, 57, 43, 0.16);
}

.booking-list-empty-slot {
  color: #8a8f98;
  font-size: 0.95rem;
}

.booking-list-slot-header .booking-list-empty-slot {
  flex: 1 1 100%;
}

.per-page-label {
  cursor: pointer;
  user-select: none;
  margin: 0 0 0.15rem;
  font-weight: normal !important;
  font-size: 1em;
  padding: 0.75rem;
  border-radius: 2px;
}

.per-page-label:hover {
  background-color: #eef5f8 !important;
}

.card-footer .el-select {
  width: 0;
  height: 0;
  overflow: hidden !important;
}

.booking-list-view-select {
  max-width: 140px;
  margin-left: auto;
}

.booking-list-slot-identity,
.booking-list-slot-meta {
  display: block;
}

.booking-list-slot-agent {
  color: #12576e !important;
  font-size: 1rem;
  font-weight: bold;
}

.table-grouped {
  border: 1px solid #dee2e6;
  border-left: 0.3rem solid #12576e;
  padding-left: 0.5rem;
  border-radius: 1rem 0 0 1rem;
}

.table-grouped .table {
  margin: 0 !important;
  padding-left: 0.5rem !important;
  margin-bottom: 5px !important;
}

.table-grouped .booking-list-vehicle-booking {
  margin-bottom: 1.15rem !important;
}

@media (max-width: 767.98px) {
  // Título do horário na linha inteira; link do lote, resumo e botão de carro
  // descem para a linha de baixo em vez de espremer o título e vazar da tela
  .booking-list-slot-header {
    flex-wrap: wrap;
    align-items: center;
    gap: 0 0.75rem;

    .h3 {
      flex: 1 1 100%;
    }

    .booking-list-batch-link,
    .booking-list-vehicle-summary {
      margin: 0.25rem 0 0 0.5rem;
    }

    .booking-list-vehicle-summary {
      white-space: normal;
    }

    .booking-list-resources-button {
      margin: 0.25rem 0 0 auto;
    }
  }

  .booking-list-tabs {
    .el-tabs__nav-wrap.is-scrollable {
      padding: 0;
    }

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
      display: none !important;
    }

    .el-tabs__nav-scroll {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: contain;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .el-tabs__nav {
      float: none;
      display: inline-flex;
      transform: none !important;
    }

    .el-tabs__item {
      flex-shrink: 0;
    }
  }
}

.booking-list-timeline.timeline-one-side {
  &:before {
    content: none;
  }

  .booking-list-timeline-hour-group {
    position: relative;
    display: flow-root;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 1rem;
      border-right: 2px solid #e9ecef;
      z-index: 0;
    }

    > .timeline-block:first-child {
      margin-top: 0;
      border-top: 1px dashed #8a8f98;
    }

    > .timeline-block:last-child {
      margin-bottom: 0;
    }
  }

  .booking-list-timeline-hour-group + .booking-list-timeline-hour-group {
    margin-top: 1.5rem;
  }

  .timeline-step {
    left: 1rem;
    color: #fff;
  }

  .timeline-block:not(.booking-list-timeline-hour):not(.booking-list-timeline-item--past)
    .timeline-step {
    width: 20px;
    height: 20px;
    font-size: 0.8rem;
  }

  .booking-list-timeline-item--past .timeline-step {
    width: 18px;
    height: 18px;
    font-size: 0.65rem;
  }

  .booking-list-timeline-hour .timeline-step {
    background-color: #12576e;
    overflow: visible;
  }

  .booking-list-timeline-hour--muted .timeline-step {
    background-color: #c5c9ce;
  }

  .timeline-content {
    width: auto;
    max-width: none;
    margin-left: 2.75rem;
    top: 0;
    padding-top: 0;
  }

  .timeline-block {
    margin: 1.15rem 0;
    padding: 5px 10px;
  }

  .timeline-block:nth-child(even) .timeline-content {
    float: none;
  }

  .badge-primary {
    background-color: #12576e;
  }

  .badge-secondary {
    background-color: #c5c9ce;
  }
}

.booking-list-timeline--distribute {
  .timeline-block:not(.booking-list-timeline-hour) > .timeline-step {
    display: none;
  }
}

.booking-list-timeline-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: #8a8f98;
  font-size: 80%;
  font-weight: 400;

  > span:first-child {
    text-transform: uppercase;
  }
  .booking-list-vehicle-summary {
    font-size: 0.9rem;
    line-height: inherit;
  }

  .booking-list-vehicle-summary--action {
    margin: 0;
    border: 0;
    background: transparent;
    padding: 0;
    font-size: 0.9rem;
    line-height: inherit;
    text-transform: inherit;
    cursor: pointer;
    box-shadow: none;

    &:hover,
    &:focus {
      background: transparent;
    }
  }

  .booking-list-resources-button {
    border: 0;
    background: transparent;
    padding: 0;
    color: #12576e;
    line-height: 1;
    box-shadow: none;

    &:hover,
    &:focus {
      border: 0;
      background: transparent;
      color: #12576e;
    }
  }
}

.timeline-block.booking-list-timeline-item--empty, 
.timeline-block.booking-list-timeline-item--empty .booking-list-timeline-line span{
  cursor: pointer;
}

.timeline-block.booking-list-timeline-item--empty:hover {
  background-color: #eef5f8;
  border-radius: 2px;
}

.booking-list-timeline
  .timeline-block.booking-list-timeline-item--colored
  > .timeline-content {
  box-shadow: inset 4px 0 0 var(--booking-product-color);
  background-color: var(--booking-product-color-soft);
  border-radius: 4px;
  padding: 0.35rem 0.65rem 0.45rem;
}

.booking-list-timeline
  .timeline-block.booking-list-timeline-item--colored.booking-list-timeline-item--empty:hover
  > .timeline-content {
  background-color: var(--booking-product-color-soft);
}

.booking-list-timeline-line-side {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  .booking-list-vehicle-summary,
  .booking-list-resources-button {
    margin: 0;
  }
}

.booking-list-timeline-meta {  
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;

  small {
    color: #8a8f98;
    text-transform: uppercase;
  }
}

@media (max-width: 767.98px) {
  /* Só o meta do passeio (com ações) quebra; o da hora mantém título + ícones na mesma linha. */
  .booking-list-timeline-meta {
    flex-wrap: wrap;
  }

  .booking-list-timeline-meta > small:not(.booking-list-timeline-hour-label) {
    flex: 1 1 100%;
    width: 100%;
  }

  .booking-list-timeline-actions {
    margin-left: 0;
  }
}

.booking-list-timeline-hour .booking-list-timeline-hour-mark {
  color: #fff;
  font-size: 0.85rem;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0px;
}

.booking-list-timeline-hour .booking-list-timeline-hour-mark--long {
  font-size: 0.55rem;
}

.booking-list-timeline-hour .booking-list-timeline-hour-text {
  color: #12576e;
}

.booking-list-timeline-hour--muted .booking-list-timeline-hour-text {
  color: #c5c9ce;
}

.booking-list-timeline-hour-label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;

  .booking-list-timeline-hour-text {
    flex: 0 0 11em;
    width: 11em;
    white-space: nowrap;
  }

  .booking-list-resources-button {
    border: 0;
    background: transparent;
    padding: 0 5px 0 5px;
    color: #12576e;
    font-size: 1.2rem;
    line-height: 1;
    box-shadow: none;
    text-transform: none;

    &:hover,
    &:focus {
      border: 0;
      background: transparent;
      color: #12576e;
    }

    &:disabled {
      opacity: 0.35;
      cursor: default;
    }
  }
}

.booking-list-timeline-hour--muted .booking-list-timeline-hour-label {
  font-weight: 400;

  .booking-list-resources-button {
    color: #c5c9ce;

    &:hover,
    &:focus {
      color: #12576e;
    }

    &:disabled,
    &:disabled:hover,
    &:disabled:focus {
      color: #c5c9ce;
    }
  }
}

.booking-list-timeline-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;

  .booking-list-batch-link,
  .booking-list-vehicle-summary,
  .booking-list-resources-button {
    margin: 0;
  }
}

.modal-open .confirmed-departures-modal.modal {
  overflow: hidden;
}

.confirmed-departures-modal > .modal-dialog {
  height: calc(100% - 3.5rem);
  max-height: calc(100% - 3.5rem);

  > .modal-content {
    height: 100%;
    overflow: hidden;
  }

  > .modal-content > .modal-header {
    flex-shrink: 0;
  }

  > .modal-content > .modal-body {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
}

@media (max-width: 991.98px) {
  .confirmed-departures-modal > .modal-dialog {
    width: calc(100% - 1rem);
    max-width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    max-height: calc(100% - 1rem);
    margin: 0.5rem auto;
  }
}

</style>
